
<script>
import { layoutMethods, dashboardKankolekMethods, dashboardKankolekComputed } from "@/state/helpers";
const { Tooltip } = require('bootstrap');
import moment from 'moment';

export default {
  page: {
    title: "Kankolek Dashboard",
  },
  components: {
    
  },
  data() {
    return {
      tooltips: {},
      activeTab: 'business-segment',
      summaryTab: 'business-segment',
      comingSoonOverlay: false,
      isLoading: false
    };
  },
  computed: {
    ...dashboardKankolekComputed,
    
    // Dynamic date labels for table headers
    priorMonthLabel() {
      return moment().subtract(1, 'month').format('MMM YYYY');
    },
    pmMtdLabel() {
      const prevMonth = moment().subtract(1, 'month');
      return `${prevMonth.format('MMM')} 1 - ${moment().subtract(1, 'day').format('D')}`;
    },
    mtdLabel() {
      const currentMonth = moment();
      return `${currentMonth.format('MMM')} 1 - ${currentMonth.subtract(1, 'day').format('D')}`;
    },
    
    // Dynamic date range display for header cards
    currentMonthRange() {
      const start = moment().startOf('month').format('MMMM D');
      const end = moment().subtract(1, 'day').format('D, YYYY');
      return `${start} - ${end}`;
    },
    
    // Format date range for display
    formattedDateRange() {
      return `${moment(this.dateRange.start).format('MMM DD, YYYY')} - ${moment(this.dateRange.end).subtract(1, 'day').format('MMM DD, YYYY')}`;
    },
    // Check if Total E-Load card has millions
    // Determine scale for ALL values based on ONLY the highest Total E-Load total value
    businessSegmentScale() {
      const totalEloadValues = [
        this.totalCurrentGTV,    // PM Total
        this.totalMtdGTV    // MTD Total
      ];
      
      // Find the highest absolute value among the 3 totals
      const maxValue = Math.max(...totalEloadValues.map(val => Math.abs(val || 0)));
      
      // Determine scale: 'M' for millions, 'K' for thousands, '' for hundreds
      if (maxValue >= 1000000) return 'M';
      if (maxValue >= 1000) return 'K';
      return ''; // hundreds
    },

    currentMonth(){
      return this.kankolekDashboardSummary?.currentMonth;
    },
    pmtd(){
      return this.kankolekDashboardSummary?.pmtd;
    },
    previousMonth(){
      return this.kankolekDashboardSummary?.previousMonth
    },

    totalCurrentGTV(){
      return this.totalCurrentKankolek + this.currentMonth.total_outgoing + this.currentMonth.total_eload_sc
    },
    totalPmtdGTV(){
      return this.totalPmtdKankolek + this.pmtd.total_outgoing + this.pmtd.total_eload_sc
    },
    totalPmGTV(){
      return this.totalPreviousKankolek + this.previousMonth.total_outgoing + this.previousMonth.total_eload_sc
    },
    percentageGtv(){
      if (this.totalPmtdGTV === 0) return 0;
      return (((this.totalCurrentGTV - this.totalPmtdGTV) / this.totalPmtdGTV) * 100);
    },

    
    totalCurrentRevenue(){
      return this.currentMonth.total_incoming_mdr + this.currentMonth.total_incoming_convenience_fee + this.currentMonth.total_eload_sc + this.currentMonth.total_outgoing_transfer_fee
    },
    totalPmtdRevenue(){
      return this.pmtd.total_incoming_mdr + this.pmtd.total_incoming_convenience_fee + this.pmtd.total_eload_sc + this.pmtd.total_outgoing_transfer_fee
    },
    percentageRevenue(){
      if (this.totalPmtdRevenue === 0) return 0;
      return (((this.totalCurrentRevenue - this.totalPmtdRevenue) / this.totalPmtdRevenue) * 100);
    },
    

    totalCurrentKankolek(){
      return this.currentMonth.total_incoming;
    },
    totalPmtdKankolek(){
      return this.pmtd.total_incoming;
    },
    totalPreviousKankolek(){
      return this.pmtd.total_incoming;
    },
    // percentageKankolek(){
    //   if (this.totalPmtdKankolek === 0) return 0;
    //   return (((this.totalCurrentKankolek - this.totalPmtdKankolek) / this.totalPmtdKankolek) * 100);
    // },

    totalCurrentOutKankolek(){
      return this.currentMonth.total_outgoing;
    },
    totalPmtdOutKankolek(){
      return this.pmtd.total_outgoing;
    },
    totalPreviousOutKankolek(){
      return this.pmtd.total_outgoing;
    },
    // percentageOutKankolek(){
    //   if (this.totalPmtdKankolek === 0) return 0;
    //   return (((this.totalCurrentOutKankolek - this.totalPmtdOutKankolek) / this.totalPmtdOutKankolek) * 100);
    // },


    percentageTotalEloadSC(){
      if (this.pmtd.total_eload_sc === 0) return 0;
      return (((this.currentMonth.total_eload_sc - this.pmtd.total_eload_sc) / this.pmtd.total_eload_sc) * 100);
    },

    percentageMdr(){
      if (this.pmtd.total_incoming_mdr === 0) return 0;
      return (((this.currentMonth.total_incoming_mdr - this.pmtd.total_incoming_mdr) / this.pmtd.total_incoming_mdr) * 100);
    },

    percentageKolekFee(){
      if (this.pmtd.total_incoming_convenience_fee === 0) return 0;
      return (((this.currentMonth.total_incoming_convenience_fee - this.pmtd.total_incoming_convenience_fee) / this.pmtd.total_incoming_convenience_fee) * 100);
    },

    // Breakdown (KOLEK)
    kolekPmRevenue(){
      return this.previousMonth.total_incoming_convenience_fee;
    },
    kolekPmCm1(){
      return this.previousMonth.total_incoming_convenience_fee;
    },
    kolekPmMk(){
      return this.previousMonth.total_incoming_merchant_share;
    },
    kolekPmCm2(){
      return this.previousMonth.total_incoming_convenience_fee - this.previousMonth.total_incoming_merchant_share - this.previousMonth.total_incoming_kf_netbank_share;
    },

    kolekPmtdRevenue(){
      return this.pmtd.total_incoming_convenience_fee;
    },
    kolekPmtdCm1(){
      return this.pmtd.total_incoming_convenience_fee;
    },
    kolekPmtdMk(){
      return this.pmtd.total_incoming_merchant_share;
    },
    kolekPmtdCm2(){
      return this.pmtd.total_incoming_convenience_fee - this.pmtd.total_incoming_merchant_share - this.pmtd.total_incoming_kf_netbank_share;
    },

    kolekCurrentRevenue(){
      return this.currentMonth.total_incoming_convenience_fee;
    },
    kolekCurrentCm1(){
      return this.currentMonth.total_incoming_convenience_fee;
    },
    kolekCurrentMk(){
      return this.currentMonth.total_incoming_merchant_share;
    },
    kolekCurrentCm2(){
      return this.currentMonth.total_incoming_convenience_fee - this.currentMonth.total_incoming_merchant_share - this.currentMonth.total_incoming_kf_netbank_share;
    },


    // Breakdown (MDR)
    mdrPmRevenue(){
      return this.previousMonth.total_incoming_mdr;
    },
    mdrPmCm1(){
      return this.previousMonth.total_incoming_mdr;
    },
    mdrPmMk(){
      return 0;
    },
    mdrPmCm2(){
      return this.previousMonth.total_incoming_mdr - this.previousMonth.total_incoming_mdr_netbank_share;
    },

    mdrPmtdRevenue(){
      return this.pmtd.total_incoming_mdr;
    },
    mdrPmtdCm1(){
      return this.pmtd.total_incoming_mdr;
    },
    mdrPmtdMk(){
      return 0;
    },
    mdrPmtdCm2(){
      return this.pmtd.total_incoming_mdr - this.pmtd.total_incoming_mdr_netbank_share;
    },

    mdrCurrentRevenue(){
      return this.currentMonth.total_incoming_mdr;
    },
    mdrCurrentCm1(){
      return this.currentMonth.total_incoming_mdr;
    },
    mdrCurrentMk(){
      return 0;
    },
    mdrCurrentCm2(){
      return this.currentMonth.total_incoming_mdr - this.currentMonth.total_incoming_mdr_netbank_share;
    },


    // Transfer (MDR)
    transferPmRevenue(){
      return this.previousMonth.total_outgoing_transfer_fee;
    },
    transferPmCm1(){
      return this.previousMonth.total_outgoing_transfer_fee;
    },
    transferPmMk(){
      return 0;
    },
    transferPmCm2(){
      return this.previousMonth.total_outgoing_transfer_fee - this.previousMonth.total_outgoing_netbank_share;
    },

    transferPmtdRevenue(){
      return this.pmtd.total_outgoing_transfer_fee;
    },
    transferPmtdCm1(){
      return this.pmtd.total_outgoing_transfer_fee;
    },
    transferPmtdMk(){
      return 0;
    },
    transferPmtdCm2(){
      return this.pmtd.total_outgoing_transfer_fee - this.pmtd.total_outgoing_netbank_share;
    },

    transferCurrentRevenue(){
      return this.currentMonth.total_outgoing_transfer_fee;
    },
    transferCurrentCm1(){
      return this.currentMonth.total_outgoing_transfer_fee;
    },
    transferCurrentMk(){
      return 0;
    },
    transferCurrentCm2(){
      return this.currentMonth.total_outgoing_transfer_fee - this.currentMonth.total_outgoing_netbank_share;
    },


    // Breakdown (TOTAL)
    totPmRevenue(){
      return this.kolekPmRevenue + this.mdrPmRevenue + this.transferPmRevenue;
    },
    totPmCm1(){
      return this.kolekPmCm1 + this.mdrPmCm1 + this.transferPmCm1;
    },
    totPmMk(){
      return this.kolekPmMk + this.mdrPmMk + this.transferPmMk;
    },  
    totPmCm2(){
      return this.kolekPmCm2+ this.mdrPmCm2 + this.transferPmCm2;
    },

    totPmtdRevenue(){
      return this.kolekPmtdRevenue + this.mdrPmtdRevenue + this.transferPmtdRevenue;
    },
    totPmtdCm1(){
      return this.kolekPmtdCm1 + this.mdrPmtdCm1 + this.transferPmtdCm1;
    },
    totPmtdMk(){
      return this.kolekPmtdMk + this.mdrPmtdMk + this.transferPmtdMk;
    },
    totPmtdCm2(){
      return this.kolekPmtdCm2+ this.mdrPmtdCm2 + this.transferPmtdCm2;
    },

    totCurrentRevenue(){
      return this.kolekCurrentRevenue + this.mdrCurrentRevenue + this.transferCurrentRevenue;
    },
    totCurrentCm1(){
      return this.kolekCurrentCm1 + this.mdrCurrentCm1 + this.transferCurrentCm1;
    },
    totCurrentMk(){
      return this.kolekCurrentMk + this.mdrCurrentMk + this.transferCurrentMk;
    },
    totCurrentCm2(){
      return this.kolekCurrentCm2 + this.mdrCurrentCm2 + this.transferCurrentCm2;
    },


    totPmNetbankShare(){
      return this.previousMonth.total_incoming_kf_netbank_share + this.previousMonth.total_incoming_mdr_netbank_share;
    },
    totPmtdNetbankShare(){
      return this.pmtd.total_incoming_kf_netbank_share + this.pmtd.total_incoming_mdr_netbank_share;
    },
    totCurrentNetbankShare(){
      return this.currentMonth.total_incoming_kf_netbank_share + this.currentMonth.total_incoming_mdr_netbank_share;
    },

    totalPmDeductions(){
      return this.previousMonth.total_incoming_merchant_share + this.totPmNetbankShare + this.previousMonth.total_outgoing_netbank_share;
    },
    totalPmtdDeductions(){
      return this.pmtd.total_incoming_merchant_share + this.totPmtdNetbankShare + this.pmtd.total_outgoing_netbank_share;
    },
    totalCurrentDeductions(){
      return this.currentMonth.total_incoming_merchant_share + this.totCurrentNetbankShare + this.currentMonth.total_outgoing_netbank_share;
    },

    pmPerCm2OfRev(){
      return (this.totPmCm2 / this.totPmRevenue * 100).toFixed(2) ;
    },
    pmtdPerCm2OfRev(){
      return (this.totPmtdCm2 / this.totPmtdRevenue * 100).toFixed(2);
    },
    currentPerCm2OfRev(){
      return (this.totCurrentCm2 / this.totCurrentRevenue * 100).toFixed(2);
    },

    pmPerCm2OfGtv(){
      return (this.totPmCm2 / this.totalPmGTV * 100).toFixed(2);
    },
    pmtdPerCm2OfGtv(){
      return (this.totPmtdCm2 / this.totalPmtdGTV * 100).toFixed(2);
    },
    currentPerCm2OfGtv(){
      return (this.totCurrentCm2 / this.totalCurrentGTV * 100).toFixed(2);
    },
    

    gtvPercentage(){
      return ((this.totalCurrentGTV - this.totalPmtdGTV) /  this.totalPmtdGTV) * 100; 
    },
    revenuePercentage(){
      return ((this.totCurrentRevenue - this.totPmtdRevenue) /  this.totPmtdRevenue) * 100; 
    },
    cm1Percentage(){
      return ((this.totCurrentCm1 - this.totPmtdCm1) /  this.totPmtdCm1) * 100; 
    },

    kankolekPercentage(){
      return ((this.totalCurrentKankolek - this.totalPmtdKankolek) /  this.totalPmtdKankolek) * 100; 
    },
    kankolekOutPercentage(){
      return ((this.totalCurrentOutKankolek - this.totalPmtdOutKankolek) /  this.totalPmtdOutKankolek) * 100; 
    },
    eloadScPercentage(){
      return ((this.currentMonth.total_eload_sc - this.currentMonth.total_eload_sc) /  this.pmtd.total_eload_sc) * 100; 
    },
    revenueMdrPercentage(){
      return ((this.mdrCurrentRevenue - this.mdrPmtdRevenue) /  this.mdrPmtdRevenue) * 100; 
    },
    revenueKFPercentage(){
      return ((this.kolekCurrentRevenue - this.kolekPmtdRevenue) /  this.kolekPmtdRevenue) * 100; 
    },
    revenueTransferPercentage(){
      return ((this.currentMonth.total_outgoing_transfer_fee - this.pmtd.total_outgoing_transfer_fee) /  this.pmtd.total_outgoing_transfer_fee) * 100; 
    },

    cm1MdrPercentage(){
      return ((this.mdrCurrentCm1 - this.mdrPmtdCm1) /  this.mdrPmtdCm1) * 100; 
    },
    cm1KfPercentage(){
      return ((this.kolekCurrentCm1 - this.kolekPmtdCm1) /  this.kolekPmtdCm1) * 100; 
    },
    cm1TransferPercentage(){
      return ((this.currentMonth.total_outgoing_transfer_fee - this.pmtd.total_outgoing_transfer_fee) /  this.pmtd.total_outgoing_transfer_fee) * 100; 
    }
  },
  
  methods: {
    ...layoutMethods,
    ...dashboardKankolekMethods,
    
    formatCurrency(amount) {
      if (amount === 0 || !amount) return '--';
      return new Intl.NumberFormat('en-PH', {
        style: 'currency',
        currency: 'PHP',
        minimumFractionDigits: 0,
        maximumFractionDigits: 0
      }).format(amount);
    },
    // Format number for Daily Transactions with M/K suffix
    formatNumber(number) {
      if (number === 0 || !number) return '--';
      return this.formatValue(number);
    },
    getChangeClass(changeType) {
      return {
        'text-success': changeType === 'positive',
        'text-danger': changeType === 'negative',
        'text-muted': changeType === 'neutral'
      };
    },
    initTooltip(element, title, content) {
      if (element && !this.tooltips[element.id]) {
        const tooltip = new Tooltip(element, {
          title: `<strong>${title}</strong><br>${content}`,
          html: true,
          placement: 'top',
          trigger: 'hover',
          container: 'body'
        });
        this.tooltips[element.id] = tooltip;
      }
    },
    initializeAllTooltips() {
      // Dispose existing tooltips first to prevent duplicates
      const existingTooltips = [].slice.call(document.querySelectorAll('[data-bs-toggle="tooltip"]'));
      existingTooltips.forEach(tooltipEl => {
        const tooltipInstance = Tooltip.getInstance(tooltipEl);
        if (tooltipInstance) {
          tooltipInstance.dispose();
        }
      });
      
      // Initialize new tooltips with better positioning
      const tooltipTriggerList = [].slice.call(document.querySelectorAll('[data-bs-toggle="tooltip"]'));
      tooltipTriggerList.map(function (tooltipTriggerEl) {
        return new Tooltip(tooltipTriggerEl, {
          html: true,
          boundary: 'window',
          container: 'body',
          customClass: 'dashboard-tooltip-left',
          fallbackPlacements: ['top', 'bottom', 'right', 'left']
        });
      });
    },
    // Format tooltip text with "PM MTD" label on top and complete value on bottom
    formatTooltip(value) {
      const completeValue = this.getCompleteValue(value);
      return `
        <div class="dashboard-tooltip-content">
          <div class="dashboard-tooltip-title">PM MTD</div>
          <div class="dashboard-tooltip-value">${completeValue}</div>
        </div>
      `;
    },
    setActiveTab(tab) {
      this.activeTab = tab;
    },
    setSummaryTab(tab) {
      this.summaryTab = tab;
      this.$nextTick(() => {
        this.initializeAllTooltips();
      });
    },
    setDailyTransactionTab(tab) {
      this.dailyTransactionTab = tab;
    },
    
    // Format value for Active Users and Daily Transactions (normal M/K conversion, no 0M/0K)
    formatValue(value) {
      if (value === 0 || !value) return '--';
      
      const absValue = Math.abs(value);
      
      // If in hundreds, show as is
      if (absValue < 1000) {
        return Math.round(value).toString();
      }
      
      // If in thousands, show with K
      if (absValue < 1000000) {
        return Math.floor(value / 1000) + 'K';
      }
      
      // If in millions, show with M
      return Math.floor(value / 1000000) + 'M';
    },
    
    // Format value for Business Segment and Summary P&L tables using the single scale yezsirs
    formatBusinessSegmentValue(value) {
      if (value === 0 || !value) return '--';
      
      const absValue = Math.abs(value);
      var scale = this.businessSegmentScale;

      if(absValue > 1000000){
        scale = 'M';
      } else if(absValue > 1000){
        scale = 'K'
      }
      
      if (scale === 'M') {
        // Millions scale: convert K to 0M, M to M
        if (absValue < 1000000) {
          return '0M';
        }
        return Math.floor(value / 1000000) + 'M';
      } else if (scale === 'K') {
        // Thousands scale: convert hundreds to 0K, K to K
        if (absValue < 1000) {
          return '0K';
        }
        return Math.floor(value / 1000) + 'K';
      } else {
        // Hundreds scale: show as is
        return Math.round(value).toString();
      }
    },
    
    // Get complete value for tooltip (no decimals)
    getCompleteValue(value) {
      if (value === 0 || !value) return '--';
      return new Intl.NumberFormat('en-PH', {
        style: 'currency',
        currency: 'PHP',
        minimumFractionDigits: 0,
        maximumFractionDigits: 0
      }).format(value);
    },

    // Format count value for tooltip (comma-separated, no peso sign)
    formatCountTooltip(value) {
      if (value === 0 || !value) return '--';
      return new Intl.NumberFormat('en-PH').format(value);
    },
    
    formatPercentage(value) {
      const n = Number(value);
      if (!Number.isFinite(n) || n === 0) return '0%';
      return `${Math.abs(n).toFixed(1)}%`;
    },
    
    getPercentageClass(value) {
      if (value === 0) return 'text-neutral';
      if (value > 0) return 'text-success';
      if (value < 0) return 'text-danger';
      return 'text-muted';
    },
    
    async loadDashboardData() {
      try {
        this.isLoading = true;
        
        // Load summary and active users data
        await Promise.all([
          this.actionDashboardKankolek({action: "summary"}),
          this.actionDashboardKankolek({action: "active-users"})
        ]);
        
        this.isLoading = false;
        
        // Reinitialize tooltips after data loads
        this.$nextTick(() => {
          this.initializeAllTooltips();
        });
      } catch (error) {
        console.error('Error loading dashboard data:', error);
        this.isLoading = false;
      }
    },
    formatDateHeader(dateString) {
      // Convert date string to proper format (e.g. "Sep 24, 2025")
      const date = moment(dateString);
      return date.format('MMM D, YYYY');
    }
  },
  async mounted() {
    this.changeTitle({ title: "Kankolek Dashboard" });
    this.changeBreadCrumb({
      breadCrumbs: [
        { text: "Dashboard", to: { name: "dashboard" } },
        { text: "Kankolek", to: { name: "kanolek-dashboard" } }
      ],
    });
    
    // Load dashboard data
    await this.loadDashboardData();
    
    this.$nextTick(() => {
      this.initializeAllTooltips();
    });
  },
};
</script>

<template>
  <div class="container-fluid">
    <!-- Coming Soon Overlay -->
    <div v-if="comingSoonOverlay" class="coming-soon-overlay">
      <div class="coming-soon-content">
        <div class="text-center">
          <i class="fas fa-rocket fa-4x mb-4 text-primary"></i>
          <h2 class="fw-bold text-dark mb-3">Coming Soon</h2>
          <p class="text-muted mb-0">This E-Load Dashboard is under development and will be available soon.</p>
        </div>
      </div>
    </div>
    
    <!-- Header Cards -->
    <div class="row g-3 mb-4">
      <!-- Total E-Load Card -->
      <div class="col-lg-4 col-md-6">
        <div class="card h-100 border-0 shadow-sm position-relative card-stat">
          <div class="card-body">
            <h6 class="card-title card-label mb-3 fw-normal">Total GTV</h6>
            <div class="d-flex align-items-center mb-2">
              <h3 class="mb-0 me-2 fw-bold card-value-main cursor-pointer" data-bs-toggle="tooltip" data-bs-placement="top">
                <span class="peso-sign-gray">₱</span>{{formatBusinessSegmentValue(totalCurrentGTV)}}
              </h3>
              <span
                id="eload-percentage"
                data-bs-toggle="tooltip"
                data-bs-placement="right"
                :class="['small fw-medium cursor-pointer d-inline-flex align-items-center rounded px-2 py-1', getPercentageClass(gtvPercentage), 'bg-opacity-75']"
                :style="{ borderRadius: '4px', background: gtvPercentage === 0 ? '#F9F9F9' : (gtvPercentage > 0 ? 'var(--Success-Success-Light, #E8FFF3)' : 'var(--Danger-Danger-Light, #FFE8E8)') }"
                :title="formatTooltip(totalPmtdGTV)"
              >
                <svg v-if="gtvPercentage > 0.0" xmlns="http://www.w3.org/2000/svg" width="7" height="7" viewBox="0 0 7 7" fill="none" class="mx-1">
                  <path d="M6.46477 3.9629C6.39897 3.96328 6.33374 3.95067 6.27282 3.92579C6.2119 3.9009 6.15649 3.86424 6.10977 3.8179L3.49477 1.2079L0.879772 3.8229C0.834948 3.87524 0.779789 3.91775 0.717757 3.94776C0.655725 3.97777 0.588158 3.99464 0.519298 3.9973C0.450439 3.99996 0.381773 3.98836 0.31761 3.96322C0.253448 3.93808 0.195174 3.89995 0.146447 3.85122C0.0977193 3.8025 0.0595904 3.74422 0.0344531 3.68006C0.00931581 3.6159 -0.00228716 3.54723 0.00037259 3.47837C0.00303234 3.40951 0.0198974 3.34195 0.0499091 3.27991C0.0799207 3.21788 0.122431 3.16272 0.174772 3.1179L3.13977 0.147899C3.18625 0.101035 3.24155 0.0638379 3.30248 0.0384536C3.36341 0.0130692 3.42877 0 3.49477 0C3.56078 0 3.62613 0.0130692 3.68706 0.0384536C3.74799 0.0638379 3.80329 0.101035 3.84977 0.147899L6.81477 3.1179C6.9079 3.21158 6.96017 3.33831 6.96017 3.4704C6.96017 3.60249 6.9079 3.72922 6.81477 3.8229C6.72084 3.91344 6.59524 3.96368 6.46477 3.9629Z" fill="#50CD89"/>
                  <path d="M3.49463 6.96293C3.36202 6.96293 3.23484 6.91025 3.14108 6.81648C3.04731 6.72272 2.99463 6.59554 2.99463 6.46293V0.50293C2.99463 0.370321 3.04731 0.243145 3.14108 0.149376C3.23484 0.0556082 3.36202 0.00292969 3.49463 0.00292969C3.62724 0.00292969 3.75441 0.0556082 3.84818 0.149376C3.94195 0.243145 3.99463 0.370321 3.99463 0.50293V6.46293C3.99463 6.59554 3.94195 6.72272 3.84818 6.81648C3.75441 6.91025 3.62724 6.96293 3.49463 6.96293Z" fill="#50CD89"/>
                </svg>
                <svg v-else-if="gtvPercentage < 0.0" xmlns="http://www.w3.org/2000/svg" width="7" height="7" viewBox="0 0 7 7" fill="none" class="mx-1">
                  <path d="M3.49477 6.95996C3.42897 6.96034 3.36374 6.94773 3.30282 6.92284C3.2419 6.89796 3.18649 6.8613 3.13977 6.81496L0.174772 3.81996C0.122431 3.77513 0.0799207 3.71997 0.0499091 3.65794C0.0198974 3.59591 0.00303234 3.52834 0.00037259 3.45948C-0.00228716 3.39062 0.00931581 3.32196 0.0344531 3.2578C0.0595904 3.19363 0.0977193 3.13536 0.146447 3.08663C0.195174 3.0379 0.253448 2.99978 0.31761 2.97464C0.381773 2.9495 0.450439 2.9379 0.519299 2.94056C0.588158 2.94322 0.655725 2.96008 0.717757 2.99009C0.779789 3.02011 0.834948 3.06262 0.879772 3.11496L3.49477 5.72996L6.10977 3.11496C6.1546 3.06262 6.20975 3.02011 6.27179 2.99009C6.33382 2.96008 6.40139 2.94322 6.47025 2.94056C6.53911 2.9379 6.60777 2.9495 6.67193 2.97464C6.7361 2.99978 6.79437 3.0379 6.8431 3.08663C6.89182 3.13536 6.92995 3.19363 6.95509 3.2578C6.98023 3.32196 6.99183 3.39062 6.98917 3.45948C6.98651 3.52834 6.96965 3.59591 6.93964 3.65794C6.90962 3.71997 6.86711 3.77513 6.81477 3.81996L3.84977 6.78996C3.80518 6.84084 3.75072 6.88214 3.6897 6.91136C3.62868 6.94058 3.56237 6.95711 3.49477 6.95996Z" fill="#D9214E"/>
                  <path d="M3.49463 6.96C3.36202 6.96 3.23484 6.90732 3.14108 6.81355C3.04731 6.71979 2.99463 6.59261 2.99463 6.46V0.5C2.99463 0.367392 3.04731 0.240215 3.14108 0.146447C3.23484 0.0526785 3.36202 0 3.49463 0C3.62724 0 3.75441 0.0526785 3.84818 0.146447C3.94195 0.240215 3.99463 0.367392 3.99463 0.5V6.46C3.99463 6.59261 3.94195 6.71979 3.84818 6.81355C3.75441 6.90732 3.62724 6.96 3.49463 6.96Z" fill="#D9214E"/>
                </svg>
                {{ formatPercentage(gtvPercentage) }}
              </span>
            </div>
            <p class="small card-date mb-3">{{ currentMonthRange }}</p>
            
            <div class="border-top pt-3 mt-3">
              <div class="d-flex justify-content-between align-items-center">
                <span class="medium card-label">Kankolek</span>
                <div class="d-flex align-items-center">
                  <span 
                    class="fw-bold card-value-dark cursor-pointer"
                  >
                    ₱{{ formatBusinessSegmentValue(totalCurrentKankolek) }}
                  </span>
                  <span
                    data-bs-toggle="tooltip"
                    data-bs-placement="top"
                    :title="formatTooltip(totalPmtdKankolek)" 
                    :class="['small fw-medium d-inline-flex align-items-center rounded percentage-badge-small', getPercentageClass(kankolekPercentage)]">
                    <svg v-if="kankolekPercentage > 0.0" xmlns="http://www.w3.org/2000/svg" width="7" height="7" viewBox="0 0 7 7" fill="none">
                      <path d="M6.46477 3.9629C6.39897 3.96328 6.33374 3.95067 6.27282 3.92579C6.2119 3.9009 6.15649 3.86424 6.10977 3.8179L3.49477 1.2079L0.879772 3.8229C0.834948 3.87524 0.779789 3.91775 0.717757 3.94776C0.655725 3.97777 0.588158 3.99464 0.519298 3.9973C0.450439 3.99996 0.381773 3.98836 0.31761 3.96322C0.253448 3.93808 0.195174 3.89995 0.146447 3.85122C0.0977193 3.8025 0.0595904 3.74422 0.0344531 3.68006C0.00931581 3.6159 -0.00228716 3.54723 0.00037259 3.47837C0.00303234 3.40951 0.0198974 3.34195 0.0499091 3.27991C0.0799207 3.21788 0.122431 3.16272 0.174772 3.1179L3.13977 0.147899C3.18625 0.101035 3.24155 0.0638379 3.30248 0.0384536C3.36341 0.0130692 3.42877 0 3.49477 0C3.56078 0 3.62613 0.0130692 3.68706 0.0384536C3.74799 0.0638379 3.80329 0.101035 3.84977 0.147899L6.81477 3.1179C6.9079 3.21158 6.96017 3.33831 6.96017 3.4704C6.96017 3.60249 6.9079 3.72922 6.81477 3.8229C6.72084 3.91344 6.59524 3.96368 6.46477 3.9629Z" fill="#50CD89"/>
                      <path d="M3.49463 6.96293C3.36202 6.96293 3.23484 6.91025 3.14108 6.81648C3.04731 6.72272 2.99463 6.59554 2.99463 6.46293V0.50293C2.99463 0.370321 3.04731 0.243145 3.14108 0.149376C3.23484 0.0556082 3.36202 0.00292969 3.49463 0.00292969C3.62724 0.00292969 3.75441 0.0556082 3.84818 0.149376C3.94195 0.243145 3.99463 0.370321 3.99463 0.50293V6.46293C3.99463 6.59554 3.94195 6.72272 3.84818 6.81648C3.75441 6.91025 3.62724 6.96293 3.49463 6.96293Z" fill="#50CD89"/>
                    </svg>
                    <svg v-else-if="kankolekPercentage < 0.0" xmlns="http://www.w3.org/2000/svg" width="7" height="7" viewBox="0 0 7 7" fill="none">
                      <path d="M3.49477 6.95996C3.42897 6.96034 3.36374 6.94773 3.30282 6.92284C3.2419 6.89796 3.18649 6.8613 3.13977 6.81496L0.174772 3.81996C0.122431 3.77513 0.0799207 3.71997 0.0499091 3.65794C0.0198974 3.59591 0.00303234 3.52834 0.00037259 3.45948C-0.00228716 3.39062 0.00931581 3.32196 0.0344531 3.2578C0.0595904 3.19363 0.0977193 3.13536 0.146447 3.08663C0.195174 3.0379 0.253448 2.99978 0.31761 2.97464C0.381773 2.9495 0.450439 2.9379 0.519299 2.94056C0.588158 2.94322 0.655725 2.96008 0.717757 2.99009C0.779789 3.02011 0.834948 3.06262 0.879772 3.11496L3.49477 5.72996L6.10977 3.11496C6.1546 3.06262 6.20975 3.02011 6.27179 2.99009C6.33382 2.96008 6.40139 2.94322 6.47025 2.94056C6.53911 2.9379 6.60777 2.9495 6.67193 2.97464C6.7361 2.99978 6.79437 3.0379 6.8431 3.08663C6.89182 3.13536 6.92995 3.19363 6.95509 3.2578C6.98023 3.32196 6.99183 3.39062 6.98917 3.45948C6.98651 3.52834 6.96965 3.59591 6.93964 3.65794C6.90962 3.71997 6.86711 3.77513 6.81477 3.81996L3.84977 6.78996C3.80518 6.84084 3.75072 6.88214 3.6897 6.91136C3.62868 6.94058 3.56237 6.95711 3.49477 6.95996Z" fill="#D9214E"/>
                      <path d="M3.49463 6.96C3.36202 6.96 3.23484 6.90732 3.14108 6.81355C3.04731 6.71979 2.99463 6.59261 2.99463 6.46V0.5C2.99463 0.367392 3.04731 0.240215 3.14108 0.146447C3.23484 0.0526785 3.36202 0 3.49463 0C3.62724 0 3.75441 0.0526785 3.84818 0.146447C3.94195 0.240215 3.99463 0.367392 3.99463 0.5V6.46C3.99463 6.59261 3.94195 6.71979 3.84818 6.81355C3.75441 6.90732 3.62724 6.96 3.49463 6.96Z" fill="#D9214E"/>
                    </svg>
                    {{ formatPercentage(kankolekPercentage) }}
                  </span>
                </div>
              </div>
              <div class="d-flex justify-content-between align-items-center">
                <span class="medium card-label">Transfer</span>
                <div class="d-flex align-items-center">
                  <span 
                    class="fw-bold card-value-dark cursor-pointer"
                  >
                    ₱{{ formatBusinessSegmentValue(totalCurrentOutKankolek) }}
                  </span>
                  <span
                    data-bs-toggle="tooltip"
                    data-bs-placement="top"
                    :title="formatTooltip(totalPmtdOutKankolek)" 
                    :class="['small fw-medium d-inline-flex align-items-center rounded percentage-badge-small', getPercentageClass(kankolekOutPercentage)]">
                    <svg v-if="kankolekOutPercentage > 0.0" xmlns="http://www.w3.org/2000/svg" width="7" height="7" viewBox="0 0 7 7" fill="none">
                      <path d="M6.46477 3.9629C6.39897 3.96328 6.33374 3.95067 6.27282 3.92579C6.2119 3.9009 6.15649 3.86424 6.10977 3.8179L3.49477 1.2079L0.879772 3.8229C0.834948 3.87524 0.779789 3.91775 0.717757 3.94776C0.655725 3.97777 0.588158 3.99464 0.519298 3.9973C0.450439 3.99996 0.381773 3.98836 0.31761 3.96322C0.253448 3.93808 0.195174 3.89995 0.146447 3.85122C0.0977193 3.8025 0.0595904 3.74422 0.0344531 3.68006C0.00931581 3.6159 -0.00228716 3.54723 0.00037259 3.47837C0.00303234 3.40951 0.0198974 3.34195 0.0499091 3.27991C0.0799207 3.21788 0.122431 3.16272 0.174772 3.1179L3.13977 0.147899C3.18625 0.101035 3.24155 0.0638379 3.30248 0.0384536C3.36341 0.0130692 3.42877 0 3.49477 0C3.56078 0 3.62613 0.0130692 3.68706 0.0384536C3.74799 0.0638379 3.80329 0.101035 3.84977 0.147899L6.81477 3.1179C6.9079 3.21158 6.96017 3.33831 6.96017 3.4704C6.96017 3.60249 6.9079 3.72922 6.81477 3.8229C6.72084 3.91344 6.59524 3.96368 6.46477 3.9629Z" fill="#50CD89"/>
                      <path d="M3.49463 6.96293C3.36202 6.96293 3.23484 6.91025 3.14108 6.81648C3.04731 6.72272 2.99463 6.59554 2.99463 6.46293V0.50293C2.99463 0.370321 3.04731 0.243145 3.14108 0.149376C3.23484 0.0556082 3.36202 0.00292969 3.49463 0.00292969C3.62724 0.00292969 3.75441 0.0556082 3.84818 0.149376C3.94195 0.243145 3.99463 0.370321 3.99463 0.50293V6.46293C3.99463 6.59554 3.94195 6.72272 3.84818 6.81648C3.75441 6.91025 3.62724 6.96293 3.49463 6.96293Z" fill="#50CD89"/>
                    </svg>
                    <svg v-else-if="kankolekOutPercentage < 0.0" xmlns="http://www.w3.org/2000/svg" width="7" height="7" viewBox="0 0 7 7" fill="none">
                      <path d="M3.49477 6.95996C3.42897 6.96034 3.36374 6.94773 3.30282 6.92284C3.2419 6.89796 3.18649 6.8613 3.13977 6.81496L0.174772 3.81996C0.122431 3.77513 0.0799207 3.71997 0.0499091 3.65794C0.0198974 3.59591 0.00303234 3.52834 0.00037259 3.45948C-0.00228716 3.39062 0.00931581 3.32196 0.0344531 3.2578C0.0595904 3.19363 0.0977193 3.13536 0.146447 3.08663C0.195174 3.0379 0.253448 2.99978 0.31761 2.97464C0.381773 2.9495 0.450439 2.9379 0.519299 2.94056C0.588158 2.94322 0.655725 2.96008 0.717757 2.99009C0.779789 3.02011 0.834948 3.06262 0.879772 3.11496L3.49477 5.72996L6.10977 3.11496C6.1546 3.06262 6.20975 3.02011 6.27179 2.99009C6.33382 2.96008 6.40139 2.94322 6.47025 2.94056C6.53911 2.9379 6.60777 2.9495 6.67193 2.97464C6.7361 2.99978 6.79437 3.0379 6.8431 3.08663C6.89182 3.13536 6.92995 3.19363 6.95509 3.2578C6.98023 3.32196 6.99183 3.39062 6.98917 3.45948C6.98651 3.52834 6.96965 3.59591 6.93964 3.65794C6.90962 3.71997 6.86711 3.77513 6.81477 3.81996L3.84977 6.78996C3.80518 6.84084 3.75072 6.88214 3.6897 6.91136C3.62868 6.94058 3.56237 6.95711 3.49477 6.95996Z" fill="#D9214E"/>
                      <path d="M3.49463 6.96C3.36202 6.96 3.23484 6.90732 3.14108 6.81355C3.04731 6.71979 2.99463 6.59261 2.99463 6.46V0.5C2.99463 0.367392 3.04731 0.240215 3.14108 0.146447C3.23484 0.0526785 3.36202 0 3.49463 0C3.62724 0 3.75441 0.0526785 3.84818 0.146447C3.94195 0.240215 3.99463 0.367392 3.99463 0.5V6.46C3.99463 6.59261 3.94195 6.71979 3.84818 6.81355C3.75441 6.90732 3.62724 6.96 3.49463 6.96Z" fill="#D9214E"/>
                    </svg>
                    {{ formatPercentage(kankolekOutPercentage) }}
                  </span>
                </div>
              </div>
              <div class="d-flex justify-content-between align-items-center">
                <span class="medium card-label">E-Load SC</span>
                <div class="d-flex align-items-center">
                  <span 
                    class="fw-bold card-value-dark cursor-pointer"
                  >
                    ₱{{ formatBusinessSegmentValue(currentMonth.total_eload_sc) }}
                  </span>
                  <span 
                    data-bs-toggle="tooltip"
                    data-bs-placement="top"
                    :title="formatTooltip(pmtd.total_eload_sc)"
                    :class="['small fw-medium d-inline-flex align-items-center rounded percentage-badge-small', getPercentageClass(eloadScPercentage)]">
                    <svg v-if="eloadScPercentage > 0.0" xmlns="http://www.w3.org/2000/svg" width="7" height="7" viewBox="0 0 7 7" fill="none">
                      <path d="M6.46477 3.9629C6.39897 3.96328 6.33374 3.95067 6.27282 3.92579C6.2119 3.9009 6.15649 3.86424 6.10977 3.8179L3.49477 1.2079L0.879772 3.8229C0.834948 3.87524 0.779789 3.91775 0.717757 3.94776C0.655725 3.97777 0.588158 3.99464 0.519298 3.9973C0.450439 3.99996 0.381773 3.98836 0.31761 3.96322C0.253448 3.93808 0.195174 3.89995 0.146447 3.85122C0.0977193 3.8025 0.0595904 3.74422 0.0344531 3.68006C0.00931581 3.6159 -0.00228716 3.54723 0.00037259 3.47837C0.00303234 3.40951 0.0198974 3.34195 0.0499091 3.27991C0.0799207 3.21788 0.122431 3.16272 0.174772 3.1179L3.13977 0.147899C3.18625 0.101035 3.24155 0.0638379 3.30248 0.0384536C3.36341 0.0130692 3.42877 0 3.49477 0C3.56078 0 3.62613 0.0130692 3.68706 0.0384536C3.74799 0.0638379 3.80329 0.101035 3.84977 0.147899L6.81477 3.1179C6.9079 3.21158 6.96017 3.33831 6.96017 3.4704C6.96017 3.60249 6.9079 3.72922 6.81477 3.8229C6.72084 3.91344 6.59524 3.96368 6.46477 3.9629Z" fill="#50CD89"/>
                      <path d="M3.49463 6.96293C3.36202 6.96293 3.23484 6.91025 3.14108 6.81648C3.04731 6.72272 2.99463 6.59554 2.99463 6.46293V0.50293C2.99463 0.370321 3.04731 0.243145 3.14108 0.149376C3.23484 0.0556082 3.36202 0.00292969 3.49463 0.00292969C3.62724 0.00292969 3.75441 0.0556082 3.84818 0.149376C3.94195 0.243145 3.99463 0.370321 3.99463 0.50293V6.46293C3.99463 6.59554 3.94195 6.72272 3.84818 6.81648C3.75441 6.91025 3.62724 6.96293 3.49463 6.96293Z" fill="#50CD89"/>
                    </svg>
                    <svg v-else-if="eloadScPercentage < 0.0" xmlns="http://www.w3.org/2000/svg" width="7" height="7" viewBox="0 0 7 7" fill="none">
                      <path d="M3.49477 6.95996C3.42897 6.96034 3.36374 6.94773 3.30282 6.92284C3.2419 6.89796 3.18649 6.8613 3.13977 6.81496L0.174772 3.81996C0.122431 3.77513 0.0799207 3.71997 0.0499091 3.65794C0.0198974 3.59591 0.00303234 3.52834 0.00037259 3.45948C-0.00228716 3.39062 0.00931581 3.32196 0.0344531 3.2578C0.0595904 3.19363 0.0977193 3.13536 0.146447 3.08663C0.195174 3.0379 0.253448 2.99978 0.31761 2.97464C0.381773 2.9495 0.450439 2.9379 0.519299 2.94056C0.588158 2.94322 0.655725 2.96008 0.717757 2.99009C0.779789 3.02011 0.834948 3.06262 0.879772 3.11496L3.49477 5.72996L6.10977 3.11496C6.1546 3.06262 6.20975 3.02011 6.27179 2.99009C6.33382 2.96008 6.40139 2.94322 6.47025 2.94056C6.53911 2.9379 6.60777 2.9495 6.67193 2.97464C6.7361 2.99978 6.79437 3.0379 6.8431 3.08663C6.89182 3.13536 6.92995 3.19363 6.95509 3.2578C6.98023 3.32196 6.99183 3.39062 6.98917 3.45948C6.98651 3.52834 6.96965 3.59591 6.93964 3.65794C6.90962 3.71997 6.86711 3.77513 6.81477 3.81996L3.84977 6.78996C3.80518 6.84084 3.75072 6.88214 3.6897 6.91136C3.62868 6.94058 3.56237 6.95711 3.49477 6.95996Z" fill="#D9214E"/>
                      <path d="M3.49463 6.96C3.36202 6.96 3.23484 6.90732 3.14108 6.81355C3.04731 6.71979 2.99463 6.59261 2.99463 6.46V0.5C2.99463 0.367392 3.04731 0.240215 3.14108 0.146447C3.23484 0.0526785 3.36202 0 3.49463 0C3.62724 0 3.75441 0.0526785 3.84818 0.146447C3.94195 0.240215 3.99463 0.367392 3.99463 0.5V6.46C3.99463 6.59261 3.94195 6.71979 3.84818 6.81355C3.75441 6.90732 3.62724 6.96 3.49463 6.96Z" fill="#D9214E"/>
                    </svg>
                    {{ formatPercentage(eloadScPercentage) }}
                  </span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <!-- Retail Card -->
      <div class="col-lg-4 col-md-6">
        <div class="card h-100 border-0 shadow-sm position-relative">
          <div class="card-body">
            <h6 class="card-title card-label mb-3 fw-normal">Total Revenue</h6>
            <div class="d-flex align-items-center mb-2">
              <h3 class="mb-0 me-2 fw-bold card-value-main cursor-pointer" data-bs-toggle="tooltip" data-bs-placement="top">
                <span class="peso-sign-gray">₱</span>{{ formatBusinessSegmentValue(totalCurrentRevenue) }}
              </h3>
              <span
                id="retail-percentage"
                data-bs-toggle="tooltip"
                data-bs-placement="right"
                :class="['small fw-medium cursor-pointer d-inline-flex align-items-center rounded px-2 py-1', getPercentageClass(revenuePercentage), 'bg-opacity-75']"
                :style="{ borderRadius: '4px', background: revenuePercentage === 0 ? '#F9F9F9' : (revenuePercentage > 0 ? 'var(--Success-Success-Light, #E8FFF3)' : 'var(--Danger-Danger-Light, #FFE8E8)') }"
                :title="formatTooltip(totalPmtdRevenue)"
              >
                <svg v-if="revenuePercentage > 0" xmlns="http://www.w3.org/2000/svg" width="7" height="7" viewBox="0 0 7 7" fill="none" class="mx-1">
                    <path d="M6.46477 3.9629C6.39897 3.96328 6.33374 3.95067 6.27282 3.92579C6.2119 3.9009 6.15649 3.86424 6.10977 3.8179L3.49477 1.2079L0.879772 3.8229C0.834948 3.87524 0.779789 3.91775 0.717757 3.94776C0.655725 3.97777 0.588158 3.99464 0.519298 3.9973C0.450439 3.99996 0.381773 3.98836 0.31761 3.96322C0.253448 3.93808 0.195174 3.89995 0.146447 3.85122C0.0977193 3.8025 0.0595904 3.74422 0.0344531 3.68006C0.00931581 3.6159 -0.00228716 3.54723 0.00037259 3.47837C0.00303234 3.40951 0.0198974 3.34195 0.0499091 3.27991C0.0799207 3.21788 0.122431 3.16272 0.174772 3.1179L3.13977 0.147899C3.18625 0.101035 3.24155 0.0638379 3.30248 0.0384536C3.36341 0.0130692 3.42877 0 3.49477 0C3.56078 0 3.62613 0.0130692 3.68706 0.0384536C3.74799 0.0638379 3.80329 0.101035 3.84977 0.147899L6.81477 3.1179C6.9079 3.21158 6.96017 3.33831 6.96017 3.4704C6.96017 3.60249 6.9079 3.72922 6.81477 3.8229C6.72084 3.91344 6.59524 3.96368 6.46477 3.9629Z" fill="#50CD89"/>
                    <path d="M3.49463 6.96293C3.36202 6.96293 3.23484 6.91025 3.14108 6.81648C3.04731 6.72272 2.99463 6.59554 2.99463 6.46293V0.50293C2.99463 0.370321 3.04731 0.243145 3.14108 0.149376C3.23484 0.0556082 3.36202 0.00292969 3.49463 0.00292969C3.62724 0.00292969 3.75441 0.0556082 3.84818 0.149376C3.94195 0.243145 3.99463 0.370321 3.99463 0.50293V6.46293C3.99463 6.59554 3.94195 6.72272 3.84818 6.81648C3.75441 6.91025 3.62724 6.96293 3.49463 6.96293Z" fill="#50CD89"/>
                </svg>
                <svg v-else-if="revenuePercentage < 0.0" xmlns="http://www.w3.org/2000/svg" width="7" height="7" viewBox="0 0 7 7" fill="none" class="mx-1">
                    <path d="M3.49477 6.95996C3.42897 6.96034 3.36374 6.94773 3.30282 6.92284C3.2419 6.89796 3.18649 6.8613 3.13977 6.81496L0.174772 3.81996C0.122431 3.77513 0.0799207 3.71997 0.0499091 3.65794C0.0198974 3.59591 0.00303234 3.52834 0.00037259 3.45948C-0.00228716 3.39062 0.00931581 3.32196 0.0344531 3.2578C0.0595904 3.19363 0.0977193 3.13536 0.146447 3.08663C0.195174 3.0379 0.253448 2.99978 0.31761 2.97464C0.381773 2.9495 0.450439 2.9379 0.519299 2.94056C0.588158 2.94322 0.655725 2.96008 0.717757 2.99009C0.779789 3.02011 0.834948 3.06262 0.879772 3.11496L3.49477 5.72996L6.10977 3.11496C6.1546 3.06262 6.20975 3.02011 6.27179 2.99009C6.33382 2.96008 6.40139 2.94322 6.47025 2.94056C6.53911 2.9379 6.60777 2.9495 6.67193 2.97464C6.7361 2.99978 6.79437 3.0379 6.8431 3.08663C6.89182 3.13536 6.92995 3.19363 6.95509 3.2578C6.98023 3.32196 6.99183 3.39062 6.98917 3.45948C6.98651 3.52834 6.96965 3.59591 6.93964 3.65794C6.90962 3.71997 6.86711 3.77513 6.81477 3.81996L3.84977 6.78996C3.80518 6.84084 3.75072 6.88214 3.6897 6.91136C3.62868 6.94058 3.56237 6.95711 3.49477 6.95996Z" fill="#D9214E"/>
                    <path d="M3.49463 6.96C3.36202 6.96 3.23484 6.90732 3.14108 6.81355C3.04731 6.71979 2.99463 6.59261 2.99463 6.46V0.5C2.99463 0.367392 3.04731 0.240215 3.14108 0.146447C3.23484 0.0526785 3.36202 0 3.49463 0C3.62724 0 3.75441 0.0526785 3.84818 0.146447C3.94195 0.240215 3.99463 0.367392 3.99463 0.5V6.46C3.99463 6.59261 3.94195 6.71979 3.84818 6.81355C3.75441 6.90732 3.62724 6.96 3.49463 6.96Z" fill="#D9214E"/>
                </svg>
                {{ formatPercentage(revenuePercentage) }}
              </span>
            </div>
            <p class="small card-date mb-3">{{ currentMonthRange }}</p>
            
            <div class="border-top pt-3 mt-3">
              <div class="d-flex justify-content-between align-items-center">
                <span class="medium card-label">MDR</span>
                <div class="d-flex align-items-center">
                  <span 
                    class="fw-bold card-value-dark cursor-pointer"
                  >
                    ₱{{ formatBusinessSegmentValue(currentMonth.total_incoming_mdr) }}
                  </span>
                  <span
                    data-bs-toggle="tooltip"
                    data-bs-placement="top"
                    :title="formatTooltip(pmtd.total_incoming_mdr)" 
                    :class="['small fw-medium d-inline-flex align-items-center rounded percentage-badge-small', getPercentageClass(revenueMdrPercentage)]">
                    <svg v-if="revenueMdrPercentage > 0.0" xmlns="http://www.w3.org/2000/svg" width="7" height="7" viewBox="0 0 7 7" fill="none">
                      <path d="M6.46477 3.9629C6.39897 3.96328 6.33374 3.95067 6.27282 3.92579C6.2119 3.9009 6.15649 3.86424 6.10977 3.8179L3.49477 1.2079L0.879772 3.8229C0.834948 3.87524 0.779789 3.91775 0.717757 3.94776C0.655725 3.97777 0.588158 3.99464 0.519298 3.9973C0.450439 3.99996 0.381773 3.98836 0.31761 3.96322C0.253448 3.93808 0.195174 3.89995 0.146447 3.85122C0.0977193 3.8025 0.0595904 3.74422 0.0344531 3.68006C0.00931581 3.6159 -0.00228716 3.54723 0.00037259 3.47837C0.00303234 3.40951 0.0198974 3.34195 0.0499091 3.27991C0.0799207 3.21788 0.122431 3.16272 0.174772 3.1179L3.13977 0.147899C3.18625 0.101035 3.24155 0.0638379 3.30248 0.0384536C3.36341 0.0130692 3.42877 0 3.49477 0C3.56078 0 3.62613 0.0130692 3.68706 0.0384536C3.74799 0.0638379 3.80329 0.101035 3.84977 0.147899L6.81477 3.1179C6.9079 3.21158 6.96017 3.33831 6.96017 3.4704C6.96017 3.60249 6.9079 3.72922 6.81477 3.8229C6.72084 3.91344 6.59524 3.96368 6.46477 3.9629Z" fill="#50CD89"/>
                      <path d="M3.49463 6.96293C3.36202 6.96293 3.23484 6.91025 3.14108 6.81648C3.04731 6.72272 2.99463 6.59554 2.99463 6.46293V0.50293C2.99463 0.370321 3.04731 0.243145 3.14108 0.149376C3.23484 0.0556082 3.36202 0.00292969 3.49463 0.00292969C3.62724 0.00292969 3.75441 0.0556082 3.84818 0.149376C3.94195 0.243145 3.99463 0.370321 3.99463 0.50293V6.46293C3.99463 6.59554 3.94195 6.72272 3.84818 6.81648C3.75441 6.91025 3.62724 6.96293 3.49463 6.96293Z" fill="#50CD89"/>
                    </svg>
                    <svg v-else-if="revenueMdrPercentage < 0.0" xmlns="http://www.w3.org/2000/svg" width="7" height="7" viewBox="0 0 7 7" fill="none">
                      <path d="M3.49477 6.95996C3.42897 6.96034 3.36374 6.94773 3.30282 6.92284C3.2419 6.89796 3.18649 6.8613 3.13977 6.81496L0.174772 3.81996C0.122431 3.77513 0.0799207 3.71997 0.0499091 3.65794C0.0198974 3.59591 0.00303234 3.52834 0.00037259 3.45948C-0.00228716 3.39062 0.00931581 3.32196 0.0344531 3.2578C0.0595904 3.19363 0.0977193 3.13536 0.146447 3.08663C0.195174 3.0379 0.253448 2.99978 0.31761 2.97464C0.381773 2.9495 0.450439 2.9379 0.519299 2.94056C0.588158 2.94322 0.655725 2.96008 0.717757 2.99009C0.779789 3.02011 0.834948 3.06262 0.879772 3.11496L3.49477 5.72996L6.10977 3.11496C6.1546 3.06262 6.20975 3.02011 6.27179 2.99009C6.33382 2.96008 6.40139 2.94322 6.47025 2.94056C6.53911 2.9379 6.60777 2.9495 6.67193 2.97464C6.7361 2.99978 6.79437 3.0379 6.8431 3.08663C6.89182 3.13536 6.92995 3.19363 6.95509 3.2578C6.98023 3.32196 6.99183 3.39062 6.98917 3.45948C6.98651 3.52834 6.96965 3.59591 6.93964 3.65794C6.90962 3.71997 6.86711 3.77513 6.81477 3.81996L3.84977 6.78996C3.80518 6.84084 3.75072 6.88214 3.6897 6.91136C3.62868 6.94058 3.56237 6.95711 3.49477 6.95996Z" fill="#D9214E"/>
                      <path d="M3.49463 6.96C3.36202 6.96 3.23484 6.90732 3.14108 6.81355C3.04731 6.71979 2.99463 6.59261 2.99463 6.46V0.5C2.99463 0.367392 3.04731 0.240215 3.14108 0.146447C3.23484 0.0526785 3.36202 0 3.49463 0C3.62724 0 3.75441 0.0526785 3.84818 0.146447C3.94195 0.240215 3.99463 0.367392 3.99463 0.5V6.46C3.99463 6.59261 3.94195 6.71979 3.84818 6.81355C3.75441 6.90732 3.62724 6.96 3.49463 6.96Z" fill="#D9214E"/>
                    </svg>
                    {{ formatPercentage(revenueMdrPercentage) }}
                  </span>
                </div>
              </div>
              <div class="d-flex justify-content-between align-items-center">
                <span class="medium card-label">Kolek Fee</span>
                <div class="d-flex align-items-center">
                  <span 
                    class="fw-bold card-value-dark cursor-pointer"
                  >
                    ₱{{ formatBusinessSegmentValue(currentMonth.total_incoming_convenience_fee) }}
                  </span>
                  <span
                    data-bs-toggle="tooltip"
                    data-bs-placement="top"
                    :title="formatTooltip(pmtd.total_incoming_convenience_fee)" 
                    :class="['small fw-medium d-inline-flex align-items-center rounded percentage-badge-small', getPercentageClass(revenueKFPercentage)]">
                    <svg v-if="revenueKFPercentage > 0.0" xmlns="http://www.w3.org/2000/svg" width="7" height="7" viewBox="0 0 7 7" fill="none">
                      <path d="M6.46477 3.9629C6.39897 3.96328 6.33374 3.95067 6.27282 3.92579C6.2119 3.9009 6.15649 3.86424 6.10977 3.8179L3.49477 1.2079L0.879772 3.8229C0.834948 3.87524 0.779789 3.91775 0.717757 3.94776C0.655725 3.97777 0.588158 3.99464 0.519298 3.9973C0.450439 3.99996 0.381773 3.98836 0.31761 3.96322C0.253448 3.93808 0.195174 3.89995 0.146447 3.85122C0.0977193 3.8025 0.0595904 3.74422 0.0344531 3.68006C0.00931581 3.6159 -0.00228716 3.54723 0.00037259 3.47837C0.00303234 3.40951 0.0198974 3.34195 0.0499091 3.27991C0.0799207 3.21788 0.122431 3.16272 0.174772 3.1179L3.13977 0.147899C3.18625 0.101035 3.24155 0.0638379 3.30248 0.0384536C3.36341 0.0130692 3.42877 0 3.49477 0C3.56078 0 3.62613 0.0130692 3.68706 0.0384536C3.74799 0.0638379 3.80329 0.101035 3.84977 0.147899L6.81477 3.1179C6.9079 3.21158 6.96017 3.33831 6.96017 3.4704C6.96017 3.60249 6.9079 3.72922 6.81477 3.8229C6.72084 3.91344 6.59524 3.96368 6.46477 3.9629Z" fill="#50CD89"/>
                      <path d="M3.49463 6.96293C3.36202 6.96293 3.23484 6.91025 3.14108 6.81648C3.04731 6.72272 2.99463 6.59554 2.99463 6.46293V0.50293C2.99463 0.370321 3.04731 0.243145 3.14108 0.149376C3.23484 0.0556082 3.36202 0.00292969 3.49463 0.00292969C3.62724 0.00292969 3.75441 0.0556082 3.84818 0.149376C3.94195 0.243145 3.99463 0.370321 3.99463 0.50293V6.46293C3.99463 6.59554 3.94195 6.72272 3.84818 6.81648C3.75441 6.91025 3.62724 6.96293 3.49463 6.96293Z" fill="#50CD89"/>
                    </svg>
                    <svg v-else-if="revenueKFPercentage < 0.0" xmlns="http://www.w3.org/2000/svg" width="7" height="7" viewBox="0 0 7 7" fill="none">
                      <path d="M3.49477 6.95996C3.42897 6.96034 3.36374 6.94773 3.30282 6.92284C3.2419 6.89796 3.18649 6.8613 3.13977 6.81496L0.174772 3.81996C0.122431 3.77513 0.0799207 3.71997 0.0499091 3.65794C0.0198974 3.59591 0.00303234 3.52834 0.00037259 3.45948C-0.00228716 3.39062 0.00931581 3.32196 0.0344531 3.2578C0.0595904 3.19363 0.0977193 3.13536 0.146447 3.08663C0.195174 3.0379 0.253448 2.99978 0.31761 2.97464C0.381773 2.9495 0.450439 2.9379 0.519299 2.94056C0.588158 2.94322 0.655725 2.96008 0.717757 2.99009C0.779789 3.02011 0.834948 3.06262 0.879772 3.11496L3.49477 5.72996L6.10977 3.11496C6.1546 3.06262 6.20975 3.02011 6.27179 2.99009C6.33382 2.96008 6.40139 2.94322 6.47025 2.94056C6.53911 2.9379 6.60777 2.9495 6.67193 2.97464C6.7361 2.99978 6.79437 3.0379 6.8431 3.08663C6.89182 3.13536 6.92995 3.19363 6.95509 3.2578C6.98023 3.32196 6.99183 3.39062 6.98917 3.45948C6.98651 3.52834 6.96965 3.59591 6.93964 3.65794C6.90962 3.71997 6.86711 3.77513 6.81477 3.81996L3.84977 6.78996C3.80518 6.84084 3.75072 6.88214 3.6897 6.91136C3.62868 6.94058 3.56237 6.95711 3.49477 6.95996Z" fill="#D9214E"/>
                      <path d="M3.49463 6.96C3.36202 6.96 3.23484 6.90732 3.14108 6.81355C3.04731 6.71979 2.99463 6.59261 2.99463 6.46V0.5C2.99463 0.367392 3.04731 0.240215 3.14108 0.146447C3.23484 0.0526785 3.36202 0 3.49463 0C3.62724 0 3.75441 0.0526785 3.84818 0.146447C3.94195 0.240215 3.99463 0.367392 3.99463 0.5V6.46C3.99463 6.59261 3.94195 6.71979 3.84818 6.81355C3.75441 6.90732 3.62724 6.96 3.49463 6.96Z" fill="#D9214E"/>
                    </svg>
                    {{ formatPercentage(revenueKFPercentage) }}
                  </span>
                </div>
              </div>
              <div class="d-flex justify-content-between align-items-center">
                <span class="medium card-label">Transfer Out</span>
                <div class="d-flex align-items-center">
                  <span 
                    class="fw-bold card-value-dark cursor-pointer"
                  >
                    ₱{{ formatBusinessSegmentValue(currentMonth.total_outgoing_transfer_fee) }}
                  </span>
                  <span
                    data-bs-toggle="tooltip"
                    data-bs-placement="top"
                    :title="formatTooltip(pmtd.total_outgoing_transfer_fee)" 
                    :class="['small fw-medium d-inline-flex align-items-center rounded percentage-badge-small', getPercentageClass(revenueTransferPercentage)]">
                    <svg v-if="revenueTransferPercentage > 0.0" xmlns="http://www.w3.org/2000/svg" width="7" height="7" viewBox="0 0 7 7" fill="none">
                      <path d="M6.46477 3.9629C6.39897 3.96328 6.33374 3.95067 6.27282 3.92579C6.2119 3.9009 6.15649 3.86424 6.10977 3.8179L3.49477 1.2079L0.879772 3.8229C0.834948 3.87524 0.779789 3.91775 0.717757 3.94776C0.655725 3.97777 0.588158 3.99464 0.519298 3.9973C0.450439 3.99996 0.381773 3.98836 0.31761 3.96322C0.253448 3.93808 0.195174 3.89995 0.146447 3.85122C0.0977193 3.8025 0.0595904 3.74422 0.0344531 3.68006C0.00931581 3.6159 -0.00228716 3.54723 0.00037259 3.47837C0.00303234 3.40951 0.0198974 3.34195 0.0499091 3.27991C0.0799207 3.21788 0.122431 3.16272 0.174772 3.1179L3.13977 0.147899C3.18625 0.101035 3.24155 0.0638379 3.30248 0.0384536C3.36341 0.0130692 3.42877 0 3.49477 0C3.56078 0 3.62613 0.0130692 3.68706 0.0384536C3.74799 0.0638379 3.80329 0.101035 3.84977 0.147899L6.81477 3.1179C6.9079 3.21158 6.96017 3.33831 6.96017 3.4704C6.96017 3.60249 6.9079 3.72922 6.81477 3.8229C6.72084 3.91344 6.59524 3.96368 6.46477 3.9629Z" fill="#50CD89"/>
                      <path d="M3.49463 6.96293C3.36202 6.96293 3.23484 6.91025 3.14108 6.81648C3.04731 6.72272 2.99463 6.59554 2.99463 6.46293V0.50293C2.99463 0.370321 3.04731 0.243145 3.14108 0.149376C3.23484 0.0556082 3.36202 0.00292969 3.49463 0.00292969C3.62724 0.00292969 3.75441 0.0556082 3.84818 0.149376C3.94195 0.243145 3.99463 0.370321 3.99463 0.50293V6.46293C3.99463 6.59554 3.94195 6.72272 3.84818 6.81648C3.75441 6.91025 3.62724 6.96293 3.49463 6.96293Z" fill="#50CD89"/>
                    </svg>
                    <svg v-else-if="revenueTransferPercentage < 0.0" xmlns="http://www.w3.org/2000/svg" width="7" height="7" viewBox="0 0 7 7" fill="none">
                      <path d="M3.49477 6.95996C3.42897 6.96034 3.36374 6.94773 3.30282 6.92284C3.2419 6.89796 3.18649 6.8613 3.13977 6.81496L0.174772 3.81996C0.122431 3.77513 0.0799207 3.71997 0.0499091 3.65794C0.0198974 3.59591 0.00303234 3.52834 0.00037259 3.45948C-0.00228716 3.39062 0.00931581 3.32196 0.0344531 3.2578C0.0595904 3.19363 0.0977193 3.13536 0.146447 3.08663C0.195174 3.0379 0.253448 2.99978 0.31761 2.97464C0.381773 2.9495 0.450439 2.9379 0.519299 2.94056C0.588158 2.94322 0.655725 2.96008 0.717757 2.99009C0.779789 3.02011 0.834948 3.06262 0.879772 3.11496L3.49477 5.72996L6.10977 3.11496C6.1546 3.06262 6.20975 3.02011 6.27179 2.99009C6.33382 2.96008 6.40139 2.94322 6.47025 2.94056C6.53911 2.9379 6.60777 2.9495 6.67193 2.97464C6.7361 2.99978 6.79437 3.0379 6.8431 3.08663C6.89182 3.13536 6.92995 3.19363 6.95509 3.2578C6.98023 3.32196 6.99183 3.39062 6.98917 3.45948C6.98651 3.52834 6.96965 3.59591 6.93964 3.65794C6.90962 3.71997 6.86711 3.77513 6.81477 3.81996L3.84977 6.78996C3.80518 6.84084 3.75072 6.88214 3.6897 6.91136C3.62868 6.94058 3.56237 6.95711 3.49477 6.95996Z" fill="#D9214E"/>
                      <path d="M3.49463 6.96C3.36202 6.96 3.23484 6.90732 3.14108 6.81355C3.04731 6.71979 2.99463 6.59261 2.99463 6.46V0.5C2.99463 0.367392 3.04731 0.240215 3.14108 0.146447C3.23484 0.0526785 3.36202 0 3.49463 0C3.62724 0 3.75441 0.0526785 3.84818 0.146447C3.94195 0.240215 3.99463 0.367392 3.99463 0.5V6.46C3.99463 6.59261 3.94195 6.71979 3.84818 6.81355C3.75441 6.90732 3.62724 6.96 3.49463 6.96Z" fill="#D9214E"/>
                    </svg>
                    {{ formatPercentage(revenueTransferPercentage) }}
                  </span>
                </div>
              </div>
              <div class="d-flex justify-content-between align-items-center">
                <span class="medium card-label">E-Load SC</span>
                <div class="d-flex align-items-center">
                  <span 
                    class="fw-bold card-value-dark cursor-pointer"
                  >
                    ₱{{ formatBusinessSegmentValue(currentMonth.total_eload_sc) }}
                  </span>
                  <span
                    data-bs-toggle="tooltip"
                    data-bs-placement="top"
                    :title="formatTooltip(pmtd.total_eload_sc)" 
                    :class="['small fw-medium d-inline-flex align-items-center rounded percentage-badge-small', getPercentageClass(eloadScPercentage)]">
                    <svg v-if="eloadScPercentage > 0.0" xmlns="http://www.w3.org/2000/svg" width="7" height="7" viewBox="0 0 7 7" fill="none">
                      <path d="M6.46477 3.9629C6.39897 3.96328 6.33374 3.95067 6.27282 3.92579C6.2119 3.9009 6.15649 3.86424 6.10977 3.8179L3.49477 1.2079L0.879772 3.8229C0.834948 3.87524 0.779789 3.91775 0.717757 3.94776C0.655725 3.97777 0.588158 3.99464 0.519298 3.9973C0.450439 3.99996 0.381773 3.98836 0.31761 3.96322C0.253448 3.93808 0.195174 3.89995 0.146447 3.85122C0.0977193 3.8025 0.0595904 3.74422 0.0344531 3.68006C0.00931581 3.6159 -0.00228716 3.54723 0.00037259 3.47837C0.00303234 3.40951 0.0198974 3.34195 0.0499091 3.27991C0.0799207 3.21788 0.122431 3.16272 0.174772 3.1179L3.13977 0.147899C3.18625 0.101035 3.24155 0.0638379 3.30248 0.0384536C3.36341 0.0130692 3.42877 0 3.49477 0C3.56078 0 3.62613 0.0130692 3.68706 0.0384536C3.74799 0.0638379 3.80329 0.101035 3.84977 0.147899L6.81477 3.1179C6.9079 3.21158 6.96017 3.33831 6.96017 3.4704C6.96017 3.60249 6.9079 3.72922 6.81477 3.8229C6.72084 3.91344 6.59524 3.96368 6.46477 3.9629Z" fill="#50CD89"/>
                      <path d="M3.49463 6.96293C3.36202 6.96293 3.23484 6.91025 3.14108 6.81648C3.04731 6.72272 2.99463 6.59554 2.99463 6.46293V0.50293C2.99463 0.370321 3.04731 0.243145 3.14108 0.149376C3.23484 0.0556082 3.36202 0.00292969 3.49463 0.00292969C3.62724 0.00292969 3.75441 0.0556082 3.84818 0.149376C3.94195 0.243145 3.99463 0.370321 3.99463 0.50293V6.46293C3.99463 6.59554 3.94195 6.72272 3.84818 6.81648C3.75441 6.91025 3.62724 6.96293 3.49463 6.96293Z" fill="#50CD89"/>
                    </svg>
                    <svg v-else-if="eloadScPercentage < 0.0" xmlns="http://www.w3.org/2000/svg" width="7" height="7" viewBox="0 0 7 7" fill="none">
                      <path d="M3.49477 6.95996C3.42897 6.96034 3.36374 6.94773 3.30282 6.92284C3.2419 6.89796 3.18649 6.8613 3.13977 6.81496L0.174772 3.81996C0.122431 3.77513 0.0799207 3.71997 0.0499091 3.65794C0.0198974 3.59591 0.00303234 3.52834 0.00037259 3.45948C-0.00228716 3.39062 0.00931581 3.32196 0.0344531 3.2578C0.0595904 3.19363 0.0977193 3.13536 0.146447 3.08663C0.195174 3.0379 0.253448 2.99978 0.31761 2.97464C0.381773 2.9495 0.450439 2.9379 0.519299 2.94056C0.588158 2.94322 0.655725 2.96008 0.717757 2.99009C0.779789 3.02011 0.834948 3.06262 0.879772 3.11496L3.49477 5.72996L6.10977 3.11496C6.1546 3.06262 6.20975 3.02011 6.27179 2.99009C6.33382 2.96008 6.40139 2.94322 6.47025 2.94056C6.53911 2.9379 6.60777 2.9495 6.67193 2.97464C6.7361 2.99978 6.79437 3.0379 6.8431 3.08663C6.89182 3.13536 6.92995 3.19363 6.95509 3.2578C6.98023 3.32196 6.99183 3.39062 6.98917 3.45948C6.98651 3.52834 6.96965 3.59591 6.93964 3.65794C6.90962 3.71997 6.86711 3.77513 6.81477 3.81996L3.84977 6.78996C3.80518 6.84084 3.75072 6.88214 3.6897 6.91136C3.62868 6.94058 3.56237 6.95711 3.49477 6.95996Z" fill="#D9214E"/>
                      <path d="M3.49463 6.96C3.36202 6.96 3.23484 6.90732 3.14108 6.81355C3.04731 6.71979 2.99463 6.59261 2.99463 6.46V0.5C2.99463 0.367392 3.04731 0.240215 3.14108 0.146447C3.23484 0.0526785 3.36202 0 3.49463 0C3.62724 0 3.75441 0.0526785 3.84818 0.146447C3.94195 0.240215 3.99463 0.367392 3.99463 0.5V6.46C3.99463 6.59261 3.94195 6.71979 3.84818 6.81355C3.75441 6.90732 3.62724 6.96 3.49463 6.96Z" fill="#D9214E"/>
                    </svg>
                    {{ formatPercentage(eloadScPercentage) }}
                  </span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="col-lg-4 col-md-6">
        <div class="card h-100 border-0 shadow-sm position-relative">
          <div class="card-body">
            <h6 class="card-title card-label mb-3 fw-normal">Total CM1</h6>
            <div class="d-flex align-items-center mb-2">
              <h3 class="mb-0 me-2 fw-bold card-value-main cursor-pointer" data-bs-toggle="tooltip" data-bs-placement="top">
                <span class="peso-sign-gray">₱</span>{{ formatBusinessSegmentValue(totalCurrentRevenue) }}
              </h3>
              <span
                id="b2b-percentage"
                data-bs-toggle="tooltip"
                data-bs-placement="right"
                :class="['small fw-medium cursor-pointer d-inline-flex align-items-center rounded px-2 py-1', getPercentageClass(cm1Percentage), 'bg-opacity-75']"
                :style="{ borderRadius: '4px', background: cm1Percentage === 0 ? '#F9F9F9' : (cm1Percentage > 0 ? 'var(--Success-Success-Light, #E8FFF3)' : 'var(--Danger-Danger-Light, #FFE8E8)') }"
                :title="formatTooltip(totalPmtdRevenue)"
              >
                <svg v-if="cm1Percentage > 0.0" xmlns="http://www.w3.org/2000/svg" width="7" height="7" viewBox="0 0 7 7" fill="none" class="mx-1">
                    <path d="M6.46477 3.9629C6.39897 3.96328 6.33374 3.95067 6.27282 3.92579C6.2119 3.9009 6.15649 3.86424 6.10977 3.8179L3.49477 1.2079L0.879772 3.8229C0.834948 3.87524 0.779789 3.91775 0.717757 3.94776C0.655725 3.97777 0.588158 3.99464 0.519298 3.9973C0.450439 3.99996 0.381773 3.98836 0.31761 3.96322C0.253448 3.93808 0.195174 3.89995 0.146447 3.85122C0.0977193 3.8025 0.0595904 3.74422 0.0344531 3.68006C0.00931581 3.6159 -0.00228716 3.54723 0.00037259 3.47837C0.00303234 3.40951 0.0198974 3.34195 0.0499091 3.27991C0.0799207 3.21788 0.122431 3.16272 0.174772 3.1179L3.13977 0.147899C3.18625 0.101035 3.24155 0.0638379 3.30248 0.0384536C3.36341 0.0130692 3.42877 0 3.49477 0C3.56078 0 3.62613 0.0130692 3.68706 0.0384536C3.74799 0.0638379 3.80329 0.101035 3.84977 0.147899L6.81477 3.1179C6.9079 3.21158 6.96017 3.33831 6.96017 3.4704C6.96017 3.60249 6.9079 3.72922 6.81477 3.8229C6.72084 3.91344 6.59524 3.96368 6.46477 3.9629Z" fill="#50CD89"/>
                    <path d="M3.49463 6.96293C3.36202 6.96293 3.23484 6.91025 3.14108 6.81648C3.04731 6.72272 2.99463 6.59554 2.99463 6.46293V0.50293C2.99463 0.370321 3.04731 0.243145 3.14108 0.149376C3.23484 0.0556082 3.36202 0.00292969 3.49463 0.00292969C3.62724 0.00292969 3.75441 0.0556082 3.84818 0.149376C3.94195 0.243145 3.99463 0.370321 3.99463 0.50293V6.46293C3.99463 6.59554 3.94195 6.72272 3.84818 6.81648C3.75441 6.91025 3.62724 6.96293 3.49463 6.96293Z" fill="#50CD89"/>
                </svg>
                <svg v-else-if="cm1Percentage < 0.0" xmlns="http://www.w3.org/2000/svg" width="7" height="7" viewBox="0 0 7 7" fill="none" class="mx-1">
                    <path d="M3.49477 6.95996C3.42897 6.96034 3.36374 6.94773 3.30282 6.92284C3.2419 6.89796 3.18649 6.8613 3.13977 6.81496L0.174772 3.81996C0.122431 3.77513 0.0799207 3.71997 0.0499091 3.65794C0.0198974 3.59591 0.00303234 3.52834 0.00037259 3.45948C-0.00228716 3.39062 0.00931581 3.32196 0.0344531 3.2578C0.0595904 3.19363 0.0977193 3.13536 0.146447 3.08663C0.195174 3.0379 0.253448 2.99978 0.31761 2.97464C0.381773 2.9495 0.450439 2.9379 0.519299 2.94056C0.588158 2.94322 0.655725 2.96008 0.717757 2.99009C0.779789 3.02011 0.834948 3.06262 0.879772 3.11496L3.49477 5.72996L6.10977 3.11496C6.1546 3.06262 6.20975 3.02011 6.27179 2.99009C6.33382 2.96008 6.40139 2.94322 6.47025 2.94056C6.53911 2.9379 6.60777 2.9495 6.67193 2.97464C6.7361 2.99978 6.79437 3.0379 6.8431 3.08663C6.89182 3.13536 6.92995 3.19363 6.95509 3.2578C6.98023 3.32196 6.99183 3.39062 6.98917 3.45948C6.98651 3.52834 6.96965 3.59591 6.93964 3.65794C6.90962 3.71997 6.86711 3.77513 6.81477 3.81996L3.84977 6.78996C3.80518 6.84084 3.75072 6.88214 3.6897 6.91136C3.62868 6.94058 3.56237 6.95711 3.49477 6.95996Z" fill="#D9214E"/>
                    <path d="M3.49463 6.96C3.36202 6.96 3.23484 6.90732 3.14108 6.81355C3.04731 6.71979 2.99463 6.59261 2.99463 6.46V0.5C2.99463 0.367392 3.04731 0.240215 3.14108 0.146447C3.23484 0.0526785 3.36202 0 3.49463 0C3.62724 0 3.75441 0.0526785 3.84818 0.146447C3.94195 0.240215 3.99463 0.367392 3.99463 0.5V6.46C3.99463 6.59261 3.94195 6.71979 3.84818 6.81355C3.75441 6.90732 3.62724 6.96 3.49463 6.96Z" fill="#D9214E"/>
                </svg>
                {{ formatPercentage(cm1Percentage) }}
              </span>
            </div>
            <p class="small card-date mb-3">{{ currentMonthRange }}</p>
            
            <div class="border-top pt-3 mt-3">
              <div class="d-flex justify-content-between align-items-center">
                <span class="medium card-label">MDR</span>
                <div class="d-flex align-items-center">
                  <span 
                    class="fw-bold card-value-dark cursor-pointer"
                  >
                    ₱{{ formatBusinessSegmentValue(currentMonth.total_incoming_mdr) }}
                  </span>
                  <span
                    data-bs-toggle="tooltip"
                    data-bs-placement="top"
                    :title="formatTooltip(pmtd.total_incoming_mdr)" 
                    :class="['small fw-medium d-inline-flex align-items-center rounded percentage-badge-small', getPercentageClass(cm1MdrPercentage)]">
                    <svg v-if="cm1MdrPercentage > 0.0" xmlns="http://www.w3.org/2000/svg" width="7" height="7" viewBox="0 0 7 7" fill="none">
                      <path d="M6.46477 3.9629C6.39897 3.96328 6.33374 3.95067 6.27282 3.92579C6.2119 3.9009 6.15649 3.86424 6.10977 3.8179L3.49477 1.2079L0.879772 3.8229C0.834948 3.87524 0.779789 3.91775 0.717757 3.94776C0.655725 3.97777 0.588158 3.99464 0.519298 3.9973C0.450439 3.99996 0.381773 3.98836 0.31761 3.96322C0.253448 3.93808 0.195174 3.89995 0.146447 3.85122C0.0977193 3.8025 0.0595904 3.74422 0.0344531 3.68006C0.00931581 3.6159 -0.00228716 3.54723 0.00037259 3.47837C0.00303234 3.40951 0.0198974 3.34195 0.0499091 3.27991C0.0799207 3.21788 0.122431 3.16272 0.174772 3.1179L3.13977 0.147899C3.18625 0.101035 3.24155 0.0638379 3.30248 0.0384536C3.36341 0.0130692 3.42877 0 3.49477 0C3.56078 0 3.62613 0.0130692 3.68706 0.0384536C3.74799 0.0638379 3.80329 0.101035 3.84977 0.147899L6.81477 3.1179C6.9079 3.21158 6.96017 3.33831 6.96017 3.4704C6.96017 3.60249 6.9079 3.72922 6.81477 3.8229C6.72084 3.91344 6.59524 3.96368 6.46477 3.9629Z" fill="#50CD89"/>
                      <path d="M3.49463 6.96293C3.36202 6.96293 3.23484 6.91025 3.14108 6.81648C3.04731 6.72272 2.99463 6.59554 2.99463 6.46293V0.50293C2.99463 0.370321 3.04731 0.243145 3.14108 0.149376C3.23484 0.0556082 3.36202 0.00292969 3.49463 0.00292969C3.62724 0.00292969 3.75441 0.0556082 3.84818 0.149376C3.94195 0.243145 3.99463 0.370321 3.99463 0.50293V6.46293C3.99463 6.59554 3.94195 6.72272 3.84818 6.81648C3.75441 6.91025 3.62724 6.96293 3.49463 6.96293Z" fill="#50CD89"/>
                    </svg>
                    <svg v-else-if="cm1MdrPercentage < 0.0" xmlns="http://www.w3.org/2000/svg" width="7" height="7" viewBox="0 0 7 7" fill="none">
                      <path d="M3.49477 6.95996C3.42897 6.96034 3.36374 6.94773 3.30282 6.92284C3.2419 6.89796 3.18649 6.8613 3.13977 6.81496L0.174772 3.81996C0.122431 3.77513 0.0799207 3.71997 0.0499091 3.65794C0.0198974 3.59591 0.00303234 3.52834 0.00037259 3.45948C-0.00228716 3.39062 0.00931581 3.32196 0.0344531 3.2578C0.0595904 3.19363 0.0977193 3.13536 0.146447 3.08663C0.195174 3.0379 0.253448 2.99978 0.31761 2.97464C0.381773 2.9495 0.450439 2.9379 0.519299 2.94056C0.588158 2.94322 0.655725 2.96008 0.717757 2.99009C0.779789 3.02011 0.834948 3.06262 0.879772 3.11496L3.49477 5.72996L6.10977 3.11496C6.1546 3.06262 6.20975 3.02011 6.27179 2.99009C6.33382 2.96008 6.40139 2.94322 6.47025 2.94056C6.53911 2.9379 6.60777 2.9495 6.67193 2.97464C6.7361 2.99978 6.79437 3.0379 6.8431 3.08663C6.89182 3.13536 6.92995 3.19363 6.95509 3.2578C6.98023 3.32196 6.99183 3.39062 6.98917 3.45948C6.98651 3.52834 6.96965 3.59591 6.93964 3.65794C6.90962 3.71997 6.86711 3.77513 6.81477 3.81996L3.84977 6.78996C3.80518 6.84084 3.75072 6.88214 3.6897 6.91136C3.62868 6.94058 3.56237 6.95711 3.49477 6.95996Z" fill="#D9214E"/>
                      <path d="M3.49463 6.96C3.36202 6.96 3.23484 6.90732 3.14108 6.81355C3.04731 6.71979 2.99463 6.59261 2.99463 6.46V0.5C2.99463 0.367392 3.04731 0.240215 3.14108 0.146447C3.23484 0.0526785 3.36202 0 3.49463 0C3.62724 0 3.75441 0.0526785 3.84818 0.146447C3.94195 0.240215 3.99463 0.367392 3.99463 0.5V6.46C3.99463 6.59261 3.94195 6.71979 3.84818 6.81355C3.75441 6.90732 3.62724 6.96 3.49463 6.96Z" fill="#D9214E"/>
                    </svg>
                    {{ formatPercentage(cm1MdrPercentage) }}
                  </span>
                </div>
              </div>
              <div class="d-flex justify-content-between align-items-center">
                <span class="medium card-label">Kolek Fee</span>
                <div class="d-flex align-items-center">
                  <span 
                    class="fw-bold card-value-dark cursor-pointer"
                  >
                    ₱{{ formatBusinessSegmentValue(currentMonth.total_incoming_convenience_fee) }}
                  </span>
                  <span
                    data-bs-toggle="tooltip"
                    data-bs-placement="top"
                    :title="formatTooltip(pmtd.total_incoming_convenience_fee)" 
                    :class="['small fw-medium d-inline-flex align-items-center rounded percentage-badge-small', getPercentageClass(cm1KfPercentage)]">
                    <svg v-if="cm1KfPercentage > 0.0" xmlns="http://www.w3.org/2000/svg" width="7" height="7" viewBox="0 0 7 7" fill="none">
                      <path d="M6.46477 3.9629C6.39897 3.96328 6.33374 3.95067 6.27282 3.92579C6.2119 3.9009 6.15649 3.86424 6.10977 3.8179L3.49477 1.2079L0.879772 3.8229C0.834948 3.87524 0.779789 3.91775 0.717757 3.94776C0.655725 3.97777 0.588158 3.99464 0.519298 3.9973C0.450439 3.99996 0.381773 3.98836 0.31761 3.96322C0.253448 3.93808 0.195174 3.89995 0.146447 3.85122C0.0977193 3.8025 0.0595904 3.74422 0.0344531 3.68006C0.00931581 3.6159 -0.00228716 3.54723 0.00037259 3.47837C0.00303234 3.40951 0.0198974 3.34195 0.0499091 3.27991C0.0799207 3.21788 0.122431 3.16272 0.174772 3.1179L3.13977 0.147899C3.18625 0.101035 3.24155 0.0638379 3.30248 0.0384536C3.36341 0.0130692 3.42877 0 3.49477 0C3.56078 0 3.62613 0.0130692 3.68706 0.0384536C3.74799 0.0638379 3.80329 0.101035 3.84977 0.147899L6.81477 3.1179C6.9079 3.21158 6.96017 3.33831 6.96017 3.4704C6.96017 3.60249 6.9079 3.72922 6.81477 3.8229C6.72084 3.91344 6.59524 3.96368 6.46477 3.9629Z" fill="#50CD89"/>
                      <path d="M3.49463 6.96293C3.36202 6.96293 3.23484 6.91025 3.14108 6.81648C3.04731 6.72272 2.99463 6.59554 2.99463 6.46293V0.50293C2.99463 0.370321 3.04731 0.243145 3.14108 0.149376C3.23484 0.0556082 3.36202 0.00292969 3.49463 0.00292969C3.62724 0.00292969 3.75441 0.0556082 3.84818 0.149376C3.94195 0.243145 3.99463 0.370321 3.99463 0.50293V6.46293C3.99463 6.59554 3.94195 6.72272 3.84818 6.81648C3.75441 6.91025 3.62724 6.96293 3.49463 6.96293Z" fill="#50CD89"/>
                    </svg>
                    <svg v-else-if="cm1KfPercentage < 0.0" xmlns="http://www.w3.org/2000/svg" width="7" height="7" viewBox="0 0 7 7" fill="none">
                      <path d="M3.49477 6.95996C3.42897 6.96034 3.36374 6.94773 3.30282 6.92284C3.2419 6.89796 3.18649 6.8613 3.13977 6.81496L0.174772 3.81996C0.122431 3.77513 0.0799207 3.71997 0.0499091 3.65794C0.0198974 3.59591 0.00303234 3.52834 0.00037259 3.45948C-0.00228716 3.39062 0.00931581 3.32196 0.0344531 3.2578C0.0595904 3.19363 0.0977193 3.13536 0.146447 3.08663C0.195174 3.0379 0.253448 2.99978 0.31761 2.97464C0.381773 2.9495 0.450439 2.9379 0.519299 2.94056C0.588158 2.94322 0.655725 2.96008 0.717757 2.99009C0.779789 3.02011 0.834948 3.06262 0.879772 3.11496L3.49477 5.72996L6.10977 3.11496C6.1546 3.06262 6.20975 3.02011 6.27179 2.99009C6.33382 2.96008 6.40139 2.94322 6.47025 2.94056C6.53911 2.9379 6.60777 2.9495 6.67193 2.97464C6.7361 2.99978 6.79437 3.0379 6.8431 3.08663C6.89182 3.13536 6.92995 3.19363 6.95509 3.2578C6.98023 3.32196 6.99183 3.39062 6.98917 3.45948C6.98651 3.52834 6.96965 3.59591 6.93964 3.65794C6.90962 3.71997 6.86711 3.77513 6.81477 3.81996L3.84977 6.78996C3.80518 6.84084 3.75072 6.88214 3.6897 6.91136C3.62868 6.94058 3.56237 6.95711 3.49477 6.95996Z" fill="#D9214E"/>
                      <path d="M3.49463 6.96C3.36202 6.96 3.23484 6.90732 3.14108 6.81355C3.04731 6.71979 2.99463 6.59261 2.99463 6.46V0.5C2.99463 0.367392 3.04731 0.240215 3.14108 0.146447C3.23484 0.0526785 3.36202 0 3.49463 0C3.62724 0 3.75441 0.0526785 3.84818 0.146447C3.94195 0.240215 3.99463 0.367392 3.99463 0.5V6.46C3.99463 6.59261 3.94195 6.71979 3.84818 6.81355C3.75441 6.90732 3.62724 6.96 3.49463 6.96Z" fill="#D9214E"/>
                    </svg>
                    {{ formatPercentage(cm1KfPercentage) }}
                  </span>
                </div>
              </div>
              <div class="d-flex justify-content-between align-items-center">
                <span class="medium card-label">Transfer Out</span>
                <div class="d-flex align-items-center">
                  <span 
                    class="fw-bold card-value-dark cursor-pointer"
                  >
                    ₱{{ formatBusinessSegmentValue(currentMonth.total_outgoing_transfer_fee) }}
                  </span>
                  <span
                    data-bs-toggle="tooltip"
                    data-bs-placement="top"
                    :title="formatTooltip(pmtd.total_outgoing_transfer_fee)" 
                    :class="['small fw-medium d-inline-flex align-items-center rounded percentage-badge-small', getPercentageClass(cm1TransferPercentage)]">
                    <svg v-if="cm1TransferPercentage > 0.0" xmlns="http://www.w3.org/2000/svg" width="7" height="7" viewBox="0 0 7 7" fill="none">
                      <path d="M6.46477 3.9629C6.39897 3.96328 6.33374 3.95067 6.27282 3.92579C6.2119 3.9009 6.15649 3.86424 6.10977 3.8179L3.49477 1.2079L0.879772 3.8229C0.834948 3.87524 0.779789 3.91775 0.717757 3.94776C0.655725 3.97777 0.588158 3.99464 0.519298 3.9973C0.450439 3.99996 0.381773 3.98836 0.31761 3.96322C0.253448 3.93808 0.195174 3.89995 0.146447 3.85122C0.0977193 3.8025 0.0595904 3.74422 0.0344531 3.68006C0.00931581 3.6159 -0.00228716 3.54723 0.00037259 3.47837C0.00303234 3.40951 0.0198974 3.34195 0.0499091 3.27991C0.0799207 3.21788 0.122431 3.16272 0.174772 3.1179L3.13977 0.147899C3.18625 0.101035 3.24155 0.0638379 3.30248 0.0384536C3.36341 0.0130692 3.42877 0 3.49477 0C3.56078 0 3.62613 0.0130692 3.68706 0.0384536C3.74799 0.0638379 3.80329 0.101035 3.84977 0.147899L6.81477 3.1179C6.9079 3.21158 6.96017 3.33831 6.96017 3.4704C6.96017 3.60249 6.9079 3.72922 6.81477 3.8229C6.72084 3.91344 6.59524 3.96368 6.46477 3.9629Z" fill="#50CD89"/>
                      <path d="M3.49463 6.96293C3.36202 6.96293 3.23484 6.91025 3.14108 6.81648C3.04731 6.72272 2.99463 6.59554 2.99463 6.46293V0.50293C2.99463 0.370321 3.04731 0.243145 3.14108 0.149376C3.23484 0.0556082 3.36202 0.00292969 3.49463 0.00292969C3.62724 0.00292969 3.75441 0.0556082 3.84818 0.149376C3.94195 0.243145 3.99463 0.370321 3.99463 0.50293V6.46293C3.99463 6.59554 3.94195 6.72272 3.84818 6.81648C3.75441 6.91025 3.62724 6.96293 3.49463 6.96293Z" fill="#50CD89"/>
                    </svg>
                    <svg v-else-if="cm1TransferPercentage < 0.0" xmlns="http://www.w3.org/2000/svg" width="7" height="7" viewBox="0 0 7 7" fill="none">
                      <path d="M3.49477 6.95996C3.42897 6.96034 3.36374 6.94773 3.30282 6.92284C3.2419 6.89796 3.18649 6.8613 3.13977 6.81496L0.174772 3.81996C0.122431 3.77513 0.0799207 3.71997 0.0499091 3.65794C0.0198974 3.59591 0.00303234 3.52834 0.00037259 3.45948C-0.00228716 3.39062 0.00931581 3.32196 0.0344531 3.2578C0.0595904 3.19363 0.0977193 3.13536 0.146447 3.08663C0.195174 3.0379 0.253448 2.99978 0.31761 2.97464C0.381773 2.9495 0.450439 2.9379 0.519299 2.94056C0.588158 2.94322 0.655725 2.96008 0.717757 2.99009C0.779789 3.02011 0.834948 3.06262 0.879772 3.11496L3.49477 5.72996L6.10977 3.11496C6.1546 3.06262 6.20975 3.02011 6.27179 2.99009C6.33382 2.96008 6.40139 2.94322 6.47025 2.94056C6.53911 2.9379 6.60777 2.9495 6.67193 2.97464C6.7361 2.99978 6.79437 3.0379 6.8431 3.08663C6.89182 3.13536 6.92995 3.19363 6.95509 3.2578C6.98023 3.32196 6.99183 3.39062 6.98917 3.45948C6.98651 3.52834 6.96965 3.59591 6.93964 3.65794C6.90962 3.71997 6.86711 3.77513 6.81477 3.81996L3.84977 6.78996C3.80518 6.84084 3.75072 6.88214 3.6897 6.91136C3.62868 6.94058 3.56237 6.95711 3.49477 6.95996Z" fill="#D9214E"/>
                      <path d="M3.49463 6.96C3.36202 6.96 3.23484 6.90732 3.14108 6.81355C3.04731 6.71979 2.99463 6.59261 2.99463 6.46V0.5C2.99463 0.367392 3.04731 0.240215 3.14108 0.146447C3.23484 0.0526785 3.36202 0 3.49463 0C3.62724 0 3.75441 0.0526785 3.84818 0.146447C3.94195 0.240215 3.99463 0.367392 3.99463 0.5V6.46C3.99463 6.59261 3.94195 6.71979 3.84818 6.81355C3.75441 6.90732 3.62724 6.96 3.49463 6.96Z" fill="#D9214E"/>
                    </svg>
                    {{ formatPercentage(cm1TransferPercentage) }}
                  </span>
                </div>
              </div>
              <div class="d-flex justify-content-between align-items-center">
                <span class="medium card-label">E-Load SC</span>
                <div class="d-flex align-items-center">
                  <span class="fw-bold card-value-dark">
                    ₱{{ formatBusinessSegmentValue(currentMonth.total_eload_sc) }}
                  </span>
                  <span :class="['small fw-medium cursor-pointer d-inline-flex align-items-center rounded percentage-badge-small', getPercentageClass(eloadScPercentage)]" data-bs-toggle="tooltip" data-bs-placement="right" :title="formatTooltip(pmtd.total_eload_sc)">
                    <svg v-if="eloadScPercentage > 0.0" xmlns="http://www.w3.org/2000/svg" width="7" height="7" viewBox="0 0 7 7" fill="none">
                      <path d="M6.46477 3.9629C6.39897 3.96328 6.33374 3.95067 6.27282 3.92579C6.2119 3.9009 6.15649 3.86424 6.10977 3.8179L3.49477 1.2079L0.879772 3.8229C0.834948 3.87524 0.779789 3.91775 0.717757 3.94776C0.655725 3.97777 0.588158 3.99464 0.519298 3.9973C0.450439 3.99996 0.381773 3.98836 0.31761 3.96322C0.253448 3.93808 0.195174 3.89995 0.146447 3.85122C0.0977193 3.8025 0.0595904 3.74422 0.0344531 3.68006C0.00931581 3.6159 -0.00228716 3.54723 0.00037259 3.47837C0.00303234 3.40951 0.0198974 3.34195 0.0499091 3.27991C0.0799207 3.21788 0.122431 3.16272 0.174772 3.1179L3.13977 0.147899C3.18625 0.101035 3.24155 0.0638379 3.30248 0.0384536C3.36341 0.0130692 3.42877 0 3.49477 0C3.56078 0 3.62613 0.0130692 3.68706 0.0384536C3.74799 0.0638379 3.80329 0.101035 3.84977 0.147899L6.81477 3.1179C6.9079 3.21158 6.96017 3.33831 6.96017 3.4704C6.96017 3.60249 6.9079 3.72922 6.81477 3.8229C6.72084 3.91344 6.59524 3.96368 6.46477 3.9629Z" fill="#50CD89"/>
                      <path d="M3.49463 6.96293C3.36202 6.96293 3.23484 6.91025 3.14108 6.81648C3.04731 6.72272 2.99463 6.59554 2.99463 6.46293V0.50293C2.99463 0.370321 3.04731 0.243145 3.14108 0.149376C3.23484 0.0556082 3.36202 0.00292969 3.49463 0.00292969C3.62724 0.00292969 3.75441 0.0556082 3.84818 0.149376C3.94195 0.243145 3.99463 0.370321 3.99463 0.50293V6.46293C3.99463 6.59554 3.94195 6.72272 3.84818 6.81648C3.75441 6.91025 3.62724 6.96293 3.49463 6.96293Z" fill="#50CD89"/>
                    </svg>
                    <svg v-else-if="eloadScPercentage < 0.0" xmlns="http://www.w3.org/2000/svg" width="7" height="7" viewBox="0 0 7 7" fill="none">
                      <path d="M3.49477 6.95996C3.42897 6.96034 3.36374 6.94773 3.30282 6.92284C3.2419 6.89796 3.18649 6.8613 3.13977 6.81496L0.174772 3.81996C0.122431 3.77513 0.0799207 3.71997 0.0499091 3.65794C0.0198974 3.59591 0.00303234 3.52834 0.00037259 3.45948C-0.00228716 3.39062 0.00931581 3.32196 0.0344531 3.2578C0.0595904 3.19363 0.0977193 3.13536 0.146447 3.08663C0.195174 3.0379 0.253448 2.99978 0.31761 2.97464C0.381773 2.9495 0.450439 2.9379 0.519299 2.94056C0.588158 2.94322 0.655725 2.96008 0.717757 2.99009C0.779789 3.02011 0.834948 3.06262 0.879772 3.11496L3.49477 5.72996L6.10977 3.11496C6.1546 3.06262 6.20975 3.02011 6.27179 2.99009C6.33382 2.96008 6.40139 2.94322 6.47025 2.94056C6.53911 2.9379 6.60777 2.9495 6.67193 2.97464C6.7361 2.99978 6.79437 3.0379 6.8431 3.08663C6.89182 3.13536 6.92995 3.19363 6.95509 3.2578C6.98023 3.32196 6.99183 3.39062 6.98917 3.45948C6.98651 3.52834 6.96965 3.59591 6.93964 3.65794C6.90962 3.71997 6.86711 3.77513 6.81477 3.81996L3.84977 6.78996C3.80518 6.84084 3.75072 6.88214 3.6897 6.91136C3.62868 6.94058 3.56237 6.95711 3.49477 6.95996Z" fill="#D9214E"/>
                      <path d="M3.49463 6.96C3.36202 6.96 3.23484 6.90732 3.14108 6.81355C3.04731 6.71979 2.99463 6.59261 2.99463 6.46V0.5C2.99463 0.367392 3.04731 0.240215 3.14108 0.146447C3.23484 0.0526785 3.36202 0 3.49463 0C3.62724 0 3.75441 0.0526785 3.84818 0.146447C3.94195 0.240215 3.99463 0.367392 3.99463 0.5V6.46C3.99463 6.59261 3.94195 6.71979 3.84818 6.81355C3.75441 6.90732 3.62724 6.96 3.49463 6.96Z" fill="#D9214E"/>
                    </svg>
                    {{ formatPercentage(eloadScPercentage) }}
                  </span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- Summary P&L Tabs Section -->
    <div class="row mt-4">
      <div class="col-12">
        <div class="card border-0 shadow-sm">
          <div class="card-body">
            <!-- Tab Navigation -->
            <div class="d-flex border-bottom mb-3">
              <button 
                @click="setActiveTab('business-segment')"
                :class="['btn btn-link text-decoration-none px-3 py-2 border-0 rounded-0', { 'border-bottom border-primary tab-view-active-label': activeTab === 'business-segment', 'tab-view-inactive-label': activeTab !== 'business-segment' }]"
              >
                Business Segment
              </button>
              <button 
                @click="setActiveTab('summary-pnl')"
                :class="['btn btn-link text-decoration-none px-3 py-2 border-0 rounded-0', { 'border-bottom border-primary tab-view-active-label': activeTab === 'summary-pnl', 'tab-view-inactive-label': activeTab !== 'summary-pnl' }]"
              >
                Summary P&L
              </button>
            </div>

            <!-- Tab Content -->
            <!-- Business Segment Tab Content -->
            <div v-show="activeTab === 'business-segment'" class="tab-content">
              <div class="row">
                <div class="col-12">
                  <!-- Unified Table Structure -->
                  <div class="d-flex">
                    <!-- Fixed Left Column -->
                    <div style="min-width: 200px; position: relative; z-index: 1; box-shadow: 4px 0 8px rgba(0, 0, 0, 0.08); display: flex; flex-direction: column; align-self: stretch; border-right: 2px solid #dee2e6; margin-top: -2px;">
                      <div style="padding: 1rem 1rem; font-size: 0.95rem; background-color: #ffffff; border-bottom: 2px solid #dee2e6; line-height: 1.5; color: var(--Gray-Gray-800, #3F4254); display: flex; align-items: center; box-sizing: border-box;" class="fw-semibold">Channels</div>
                      <div style="padding: 1rem 1rem; border-bottom: 2px solid #dee2e6; font-size: 1.125rem; background-color: #F8F5FF; line-height: 1.5; font-weight: 600; color: var(--Gray-Gray-800, #3F4254); display: flex; align-items: center; box-sizing: border-box;" class="">Period View</div>
                      <div style="padding: 1rem 1rem; border-bottom: 2px solid #dee2e6; font-size: 1.125rem; background-color: #F8F5FF; font-weight: 600; line-height: 1.5; color: var(--Gray-Gray-800, #3F4254); display: flex; align-items: center; box-sizing: border-box;" class="">Revenue</div>
                      <div style="padding: 1rem 1rem; border-bottom: 2px solid #dee2e6; font-size: 1.125rem; background-color: #F8F5FF; font-weight: 600; line-height: 1.5; color: var(--Gray-Gray-800, #3F4254); display: flex; align-items: center; box-sizing: border-box;" class="">CM1</div>
                      <div style="padding: 1rem 1rem; border-bottom: 2px solid #dee2e6; font-size: 1.125rem; background-color: #F8F5FF; font-weight: 600; line-height: 1.5; color: var(--Gray-Gray-800, #3F4254); display: flex; align-items: center; box-sizing: border-box;" class="">MK</div>
                      <div style="padding: 1rem 1rem; border-bottom: 2px solid #dee2e6; font-size: 1.125rem; background-color: #F8F5FF; font-weight: 600; line-height: 1.5; color: var(--Gray-Gray-800, #3F4254); display: flex; align-items: center; box-sizing: border-box;" class="">CM2</div>
                      <div style="padding: 1rem 1rem; font-size: 1.125rem; background-color: #F8F5FF; font-weight: 600; line-height: 1.5; color: var(--Gray-Gray-800, #3F4254); display: flex; align-items: center; box-sizing: border-box;" class=""># of Active Users</div>
                    </div>
                    
                    <!-- Scrollable Data Area -->
                    <div class="flex-grow-1 me-1" style="overflow-x: auto; padding-left: 0; margin-left: 8px;">
                      <table class="table table-borderless mb-0 business-segment-table" style="min-width: 900px;">
                        <thead>
                          <tr class="border-bottom">
                            <th colspan="3" class="text-start text-muted fw-semibold" style="padding: 1rem; font-size: 0.95rem; background-color: #ffffff;">Kolek Fee</th>
                            <th colspan="3" class="text-start text-muted fw-semibold" style="padding: 1rem; font-size: 0.95rem; background-color: #ffffff;">MDR</th>
                            <th colspan="3" class="text-start text-muted fw-semibold" style="padding: 1rem; font-size: 0.95rem; background-color: #ffffff;">Transfer Out</th>
                            <th colspan="3" class="text-start text-muted fw-semibold" style="padding: 1rem; font-size: 0.95rem; background-color: #ffffff;">Total</th>
                          </tr>
                          <tr class="border-bottom">
                            <th class="text-end" style="background: #f9f9f9; color: #7E8299; width: 100px; padding: 1rem 1rem; font-size: 1rem; font-weight: 600;">PM</th>
                            <th class="text-end" style="background: #f9f9f9; color: #7E8299; width: 100px; padding: 1rem 1rem; font-size: 1rem; font-weight: 600;">PM&nbsp;MTD</th>
                            <th class="text-end" style="background: #f9f9f9; color: #7E8299; width: 100px; padding: 1rem 1rem; font-size: 1rem; font-weight: 600;">MTD</th>
                            <th class="text-end" style="color: #7E8299; width: 100px; padding: 1rem 1rem; font-size: 1rem; font-weight: 600;">PM</th>
                            <th class="text-end" style="color: #7E8299; width: 100px; padding: 1rem 1rem; font-size: 1rem; font-weight: 600;">PM&nbsp;MTD</th>
                            <th class="text-end" style="color: #7E8299; width: 100px; padding: 1rem 1rem; font-size: 1rem; font-weight: 600;">MTD</th>
                            <th class="text-end" style="background: #f9f9f9; color: #7E8299; width: 100px; padding: 1rem 1rem; font-size: 1rem; font-weight: 600;">PM</th>
                            <th class="text-end" style="background: #f9f9f9; color: #7E8299; width: 100px; padding: 1rem 1rem; font-size: 1rem; font-weight: 600;">PM&nbsp;MTD</th>
                            <th class="text-end" style="background: #f9f9f9; color: #7E8299; width: 100px; padding: 1rem 1rem; font-size: 1rem; font-weight: 600;">MTD</th>
                            <th class="text-end" style="color: #7E8299; width: 100px; padding: 1rem 1rem; font-size: 1rem; font-weight: 600;">PM</th>
                            <th class="text-end" style="color: #7E8299; width: 100px; padding: 1rem 1rem; font-size: 1rem; font-weight: 600;">PM&nbsp;MTD</th>
                            <th class="text-end" style="color: #7E8299; width: 100px; padding: 1rem 1rem; font-size: 1rem; font-weight: 600;">MTD</th>
                          </tr>
                        </thead>
                        <tbody>
                          <tr>
                            <td class="text-end" style="background: #f9f9f9;"><span data-bs-toggle="tooltip" data-bs-placement="top" :title="getCompleteValue(kolekPmRevenue)">{{ formatBusinessSegmentValue(kolekPmRevenue) }}</span></td>
                            <td class="text-end" style="background: #f9f9f9;"><span data-bs-toggle="tooltip" data-bs-placement="top" :title="getCompleteValue(kolekPmtdRevenue)">{{ formatBusinessSegmentValue(kolekPmtdRevenue) }}</span></td>
                            <td class="text-end" style="background: #f9f9f9;"><span data-bs-toggle="tooltip" data-bs-placement="top" :title="getCompleteValue(kolekCurrentRevenue)">{{ formatBusinessSegmentValue(kolekCurrentRevenue) }}</span></td>
                            <td class="text-end"><span data-bs-toggle="tooltip" data-bs-placement="top" :title="getCompleteValue(mdrPmRevenue)">{{ formatBusinessSegmentValue(mdrPmRevenue) }}</span></td>
                            <td class="text-end"><span data-bs-toggle="tooltip" data-bs-placement="top" :title="getCompleteValue(mdrPmtdRevenue)">{{ formatBusinessSegmentValue(mdrPmtdRevenue) }}</span></td>
                            <td class="text-end"><span data-bs-toggle="tooltip" data-bs-placement="top" :title="getCompleteValue(mdrCurrentRevenue)">{{ formatBusinessSegmentValue(mdrCurrentRevenue) }}</span></td>
                            <td class="text-end" style="background: #f9f9f9;"><span data-bs-toggle="tooltip" data-bs-placement="top" :title="getCompleteValue(transferPmRevenue)">{{ formatBusinessSegmentValue(transferPmRevenue) }}</span></td>
                            <td class="text-end" style="background: #f9f9f9;"><span data-bs-toggle="tooltip" data-bs-placement="top" :title="getCompleteValue(transferPmtdRevenue)">{{ formatBusinessSegmentValue(transferPmtdRevenue) }}</span></td>
                            <td class="text-end" style="background: #f9f9f9;"><span data-bs-toggle="tooltip" data-bs-placement="top" :title="getCompleteValue(transferCurrentRevenue)">{{ formatBusinessSegmentValue(transferCurrentRevenue) }}</span></td>
                            <td class="text-end"><span data-bs-toggle="tooltip" data-bs-placement="top" :title="getCompleteValue(totPmRevenue)">{{ formatBusinessSegmentValue(totPmRevenue) }}</span></td>
                            <td class="text-end"><span data-bs-toggle="tooltip" data-bs-placement="top" :title="getCompleteValue(totPmtdRevenue)">{{ formatBusinessSegmentValue(totPmtdRevenue) }}</span></td>
                            <td class="text-end"><span data-bs-toggle="tooltip" data-bs-placement="top" :title="getCompleteValue(totCurrentRevenue)">{{ formatBusinessSegmentValue(totCurrentRevenue) }}</span></td>
                          </tr>
                          <tr>
                            <td class="text-end" style="background: #f9f9f9;"><span data-bs-toggle="tooltip" data-bs-placement="top" :title="getCompleteValue(kolekPmCm1)">{{ formatBusinessSegmentValue(kolekPmCm1) }}</span></td>
                            <td class="text-end" style="background: #f9f9f9;"><span data-bs-toggle="tooltip" data-bs-placement="top" :title="getCompleteValue(kolekPmtdCm1)">{{ formatBusinessSegmentValue(kolekPmtdCm1) }}</span></td>
                            <td class="text-end" style="background: #f9f9f9;"><span data-bs-toggle="tooltip" data-bs-placement="top" :title="getCompleteValue(kolekCurrentCm1)">{{ formatBusinessSegmentValue(kolekCurrentCm1) }}</span></td>
                            <td class="text-end"><span data-bs-toggle="tooltip" data-bs-placement="top" :title="getCompleteValue(mdrPmCm1)">{{ formatBusinessSegmentValue(mdrPmCm1) }}</span></td>
                            <td class="text-end"><span data-bs-toggle="tooltip" data-bs-placement="top" :title="getCompleteValue(mdrPmtdCm1)">{{ formatBusinessSegmentValue(mdrPmtdCm1) }}</span></td>
                            <td class="text-end"><span data-bs-toggle="tooltip" data-bs-placement="top" :title="getCompleteValue(mdrCurrentCm1)">{{ formatBusinessSegmentValue(mdrCurrentCm1) }}</span></td>
                            <td class="text-end" style="background: #f9f9f9;"><span data-bs-toggle="tooltip" data-bs-placement="top" :title="getCompleteValue(transferPmCm1)">{{ formatBusinessSegmentValue(transferPmCm1) }}</span></td>
                            <td class="text-end" style="background: #f9f9f9;"><span data-bs-toggle="tooltip" data-bs-placement="top" :title="getCompleteValue(transferPmtdCm1)">{{ formatBusinessSegmentValue(transferPmtdCm1) }}</span></td>
                            <td class="text-end" style="background: #f9f9f9;"><span data-bs-toggle="tooltip" data-bs-placement="top" :title="getCompleteValue(transferCurrentCm1)">{{ formatBusinessSegmentValue(transferCurrentCm1) }}</span></td>
                            <td class="text-end"><span data-bs-toggle="tooltip" data-bs-placement="top" :title="getCompleteValue(totPmCm1)">{{ formatBusinessSegmentValue(totPmCm1) }}</span></td>
                            <td class="text-end"><span data-bs-toggle="tooltip" data-bs-placement="top" :title="getCompleteValue(totPmtdCm1)">{{ formatBusinessSegmentValue(totPmtdCm1) }}</span></td>
                            <td class="text-end"><span data-bs-toggle="tooltip" data-bs-placement="top" :title="getCompleteValue(totCurrentCm1)">{{ formatBusinessSegmentValue(totCurrentCm1) }}</span></td>
                          </tr>
                          <tr>
                            <td class="text-end" style="background: #f9f9f9;"><span data-bs-toggle="tooltip" data-bs-placement="top" :title="getCompleteValue(kolekPmMk)">{{ formatBusinessSegmentValue(kolekPmMk) }}</span></td>
                            <td class="text-end" style="background: #f9f9f9;"><span data-bs-toggle="tooltip" data-bs-placement="top" :title="getCompleteValue(kolekPmtdMk)">{{ formatBusinessSegmentValue(kolekPmtdMk) }}</span></td>
                            <td class="text-end" style="background: #f9f9f9;"><span data-bs-toggle="tooltip" data-bs-placement="top" :title="getCompleteValue(kolekCurrentMk)">{{ formatBusinessSegmentValue(kolekCurrentMk) }}</span></td>
                            <td class="text-end"><span data-bs-toggle="tooltip" data-bs-placement="top" :title="getCompleteValue(mdrPmMk)">{{ formatBusinessSegmentValue(mdrPmMk) }}</span></td>
                            <td class="text-end"><span data-bs-toggle="tooltip" data-bs-placement="top" :title="getCompleteValue(mdrPmtdMk)">{{ formatBusinessSegmentValue(mdrPmtdMk) }}</span></td>
                            <td class="text-end"><span data-bs-toggle="tooltip" data-bs-placement="top" :title="getCompleteValue(mdrCurrentMk)">{{ formatBusinessSegmentValue(mdrCurrentMk) }}</span></td>
                            <td class="text-end" style="background: #f9f9f9;"><span data-bs-toggle="tooltip" data-bs-placement="top" :title="getCompleteValue(transferPmMk)">{{ formatBusinessSegmentValue(transferPmMk) }}</span></td>
                            <td class="text-end" style="background: #f9f9f9;"><span data-bs-toggle="tooltip" data-bs-placement="top" :title="getCompleteValue(transferPmtdMk)">{{ formatBusinessSegmentValue(transferPmtdMk) }}</span></td>
                            <td class="text-end" style="background: #f9f9f9;"><span data-bs-toggle="tooltip" data-bs-placement="top" :title="getCompleteValue(transferCurrentMk)">{{ formatBusinessSegmentValue(transferCurrentMk) }}</span></td>
                            <td class="text-end"><span data-bs-toggle="tooltip" data-bs-placement="top" :title="getCompleteValue(totPmMk)">{{ formatBusinessSegmentValue(totPmMk) }}</span></td>
                            <td class="text-end"><span data-bs-toggle="tooltip" data-bs-placement="top" :title="getCompleteValue(totPmtdMk)">{{ formatBusinessSegmentValue(totPmtdMk) }}</span></td>
                            <td class="text-end"><span data-bs-toggle="tooltip" data-bs-placement="top" :title="getCompleteValue(totCurrentMk)">{{ formatBusinessSegmentValue(totCurrentMk) }}</span></td>
                          </tr>
                          <tr>
                            <td class="text-end" style="background: #f9f9f9;"><span data-bs-toggle="tooltip" data-bs-placement="top" :title="getCompleteValue(kolekPmCm2)">{{ formatBusinessSegmentValue(kolekPmCm2) }}</span></td>
                            <td class="text-end" style="background: #f9f9f9;"><span data-bs-toggle="tooltip" data-bs-placement="top" :title="getCompleteValue(kolekPmtdCm2)">{{ formatBusinessSegmentValue(kolekPmtdCm2) }}</span></td>
                            <td class="text-end" style="background: #f9f9f9;"><span data-bs-toggle="tooltip" data-bs-placement="top" :title="getCompleteValue(kolekCurrentCm2)">{{ formatBusinessSegmentValue(kolekCurrentCm2) }}</span></td>
                            <td class="text-end"><span data-bs-toggle="tooltip" data-bs-placement="top" :title="getCompleteValue(mdrPmCm2)">{{ formatBusinessSegmentValue(mdrPmCm2) }}</span></td>
                            <td class="text-end"><span data-bs-toggle="tooltip" data-bs-placement="top" :title="getCompleteValue(mdrPmtdCm2)">{{ formatBusinessSegmentValue(mdrPmtdCm2) }}</span></td>
                            <td class="text-end"><span data-bs-toggle="tooltip" data-bs-placement="top" :title="getCompleteValue(mdrCurrentCm2)">{{ formatBusinessSegmentValue(mdrCurrentCm2) }}</span></td>
                            <td class="text-end" style="background: #f9f9f9;"><span data-bs-toggle="tooltip" data-bs-placement="top" :title="getCompleteValue(transferPmCm2)">{{ formatBusinessSegmentValue(transferPmCm2) }}</span></td>
                            <td class="text-end" style="background: #f9f9f9;"><span data-bs-toggle="tooltip" data-bs-placement="top" :title="getCompleteValue(transferPmtdCm2)">{{ formatBusinessSegmentValue(transferPmtdCm2) }}</span></td>
                            <td class="text-end" style="background: #f9f9f9;"><span data-bs-toggle="tooltip" data-bs-placement="top" :title="getCompleteValue(transferCurrentCm2)">{{ formatBusinessSegmentValue(transferCurrentCm2) }}</span></td>
                            <td class="text-end"><span data-bs-toggle="tooltip" data-bs-placement="top" :title="getCompleteValue(totPmCm2)">{{ formatBusinessSegmentValue(totPmCm2) }}</span></td>
                            <td class="text-end"><span data-bs-toggle="tooltip" data-bs-placement="top" :title="getCompleteValue(totPmtdCm2)">{{ formatBusinessSegmentValue(totPmtdCm2) }}</span></td>
                            <td class="text-end"><span data-bs-toggle="tooltip" data-bs-placement="top" :title="getCompleteValue(totCurrentCm2)">{{ formatBusinessSegmentValue(totCurrentCm2) }}</span></td>
                          </tr>
                          <tr>
                            <td class="text-end" style="background: #f9f9f9;"><span data-bs-toggle="tooltip" data-bs-placement="top" :title="formatCountTooltip(kankolekActiveUsers.pm_active_user_kf)">{{ formatValue(kankolekActiveUsers.pm_active_user_kf) }}</span></td>
                            <td class="text-end" style="background: #f9f9f9;"><span data-bs-toggle="tooltip" data-bs-placement="top" :title="formatCountTooltip(kankolekActiveUsers.pmtd_active_user_kf)">{{ formatValue(kankolekActiveUsers.pmtd_active_user_kf) }}</span></td>
                            <td class="text-end" style="background: #f9f9f9;"><span data-bs-toggle="tooltip" data-bs-placement="top" :title="formatCountTooltip(kankolekActiveUsers.current_active_user_kf)">{{ formatValue(kankolekActiveUsers.current_active_user_kf) }}</span></td>
                            <td class="text-end"><span data-bs-toggle="tooltip" data-bs-placement="top" :title="formatCountTooltip(kankolekActiveUsers.pm_active_user_mdr)">{{ formatValue(kankolekActiveUsers.pm_active_user_mdr) }}</span></td>
                            <td class="text-end"><span data-bs-toggle="tooltip" data-bs-placement="top" :title="formatCountTooltip(kankolekActiveUsers.pmtd_active_user_mdr)">{{ formatValue(kankolekActiveUsers.pmtd_active_user_mdr) }}</span></td>
                            <td class="text-end"><span data-bs-toggle="tooltip" data-bs-placement="top" :title="formatCountTooltip(kankolekActiveUsers.current_active_user_mdr)">{{ formatValue(kankolekActiveUsers.current_active_user_mdr) }}</span></td>
                            <td class="text-end" style="background: #f9f9f9;"><span data-bs-toggle="tooltip" data-bs-placement="top" :title="formatCountTooltip(kankolekActiveUsers.pm_active_user_transfer)">{{ formatValue(kankolekActiveUsers.pm_active_user_transfer) }}</span></td>
                            <td class="text-end" style="background: #f9f9f9;"><span data-bs-toggle="tooltip" data-bs-placement="top" :title="formatCountTooltip(kankolekActiveUsers.pmtd_active_user_transfer)">{{ formatValue(kankolekActiveUsers.pmtd_active_user_transfer) }}</span></td>
                            <td class="text-end" style="background: #f9f9f9;"><span data-bs-toggle="tooltip" data-bs-placement="top" :title="formatCountTooltip(kankolekActiveUsers.current_active_user_transfer)">{{ formatValue(kankolekActiveUsers.current_active_user_transfer) }}</span></td>
                            <td class="text-end"><span data-bs-toggle="tooltip" data-bs-placement="top" :title="formatCountTooltip(kankolekActiveUsers.pm_active_user_total)">{{ formatValue(kankolekActiveUsers.pm_active_user_total) }}</span></td>
                            <td class="text-end"><span data-bs-toggle="tooltip" data-bs-placement="top" :title="formatCountTooltip(kankolekActiveUsers.pmtd_active_user_total)">{{ formatValue(kankolekActiveUsers.pmtd_active_user_total) }}</span></td>
                            <td class="text-end"><span data-bs-toggle="tooltip" data-bs-placement="top" :title="formatCountTooltip(kankolekActiveUsers.current_active_user_total)">{{ formatValue(kankolekActiveUsers.current_active_user_total) }}</span></td>
                          </tr>
                        </tbody>
                      </table>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <!-- Summary P&L Tab Content -->
            <div v-show="activeTab === 'summary-pnl'" class="tab-content">
              <div class="row">
                <div class="col-12">
                  <div class="table-responsive">
                    <table class="table table-borderless mb-0" style="font-size: 0.9375rem;">
                      <thead>
                        <tr class="border-bottom" style="border-bottom-width: 2px !important;">
                          <th class="fw-normal" style="padding: 0.75rem 0; font-size: 0.875rem; color: #7E8299; font-weight: 600;">Period View</th>
                          <th class="fw-normal" style="padding: 0.75rem 0; font-size: 0.875rem;"></th>
                          <th class="fw-normal text-end" style="padding: 0.75rem 0; font-size: 0.875rem; color: #7E8299; font-weight: 600;">Prior Month<br><small style="font-size: 0.75rem; color: #3F4254; font-weight: 600;">{{ priorMonthLabel }}</small></th>
                          <th class="fw-normal text-end" style="padding: 0.75rem 0; font-size: 0.875rem; color: #7E8299; font-weight: 600;">PM&nbsp;MTD<br><small style="font-size: 0.75rem; color: #3F4254; font-weight: 600;">{{ pmMtdLabel }}</small></th>
                          <th class="fw-normal text-end" style="padding: 0.75rem 0; font-size: 0.875rem; color: #7E8299; font-weight: 600;">MTD<br><small style="font-size: 0.75rem; color: #3F4254; font-weight: 600;">{{ mtdLabel }}</small></th>
                        </tr>
                      </thead>
                      <tbody>
                        <!-- Total E-Load Section -->
                        <tr>
                          <td rowspan="3" class="fw-bold align-top" style="padding: 0.5rem 0; color: #3F4254;">GTV</td>
                          <td style="padding: 0.5rem 0; color: #A1A5B7;">Kankolek</td>
                          <td class="text-end" style="padding: 0.5rem 0; color: #3F4254;"><span data-bs-toggle="tooltip" data-bs-placement="top" :title="getCompleteValue(totalPreviousKankolek)">{{ formatBusinessSegmentValue(totalPreviousKankolek) }}</span></td>
                          <td class="text-end" style="padding: 0.5rem 0; color: #3F4254;"><span data-bs-toggle="tooltip" data-bs-placement="top" :title="getCompleteValue(totalPmtdKankolek)">{{ formatBusinessSegmentValue(totalPmtdKankolek) }}</span></td>
                          <td class="text-end" style="padding: 0.5rem 0; color: #3F4254;"><span data-bs-toggle="tooltip" data-bs-placement="top" :title="getCompleteValue(totalCurrentKankolek)">{{ formatBusinessSegmentValue(totalCurrentKankolek) }}</span></td>
                        </tr>
                        <tr>
                          <td style="padding: 0.5rem 0; color: #A1A5B7;">Transfer</td>
                          <td class="text-end" style="padding: 0.5rem 0; color: #3F4254;"><span data-bs-toggle="tooltip" data-bs-placement="top" :title="getCompleteValue(previousMonth.total_outgoing)">{{ formatBusinessSegmentValue(previousMonth.total_outgoing) }}</span></td>
                          <td class="text-end" style="padding: 0.5rem 0; color: #3F4254;"><span data-bs-toggle="tooltip" data-bs-placement="top" :title="getCompleteValue(pmtd.total_outgoing)">{{ formatBusinessSegmentValue(pmtd.total_outgoing) }}</span></td>
                          <td class="text-end" style="padding: 0.5rem 0; color: #3F4254;"><span data-bs-toggle="tooltip" data-bs-placement="top" :title="getCompleteValue(currentMonth.total_outgoing)">{{ formatBusinessSegmentValue(currentMonth.total_outgoing) }}</span></td>
                        </tr>
                        <tr>
                          <td style="padding: 0.5rem 0; color: #A1A5B7;">E-Load SC</td>
                          <td class="text-end" style="padding: 0.5rem 0; color: #3F4254;"><span data-bs-toggle="tooltip" data-bs-placement="top" :title="getCompleteValue(previousMonth.total_eload_sc)">{{ formatBusinessSegmentValue(previousMonth.total_eload_sc) }}</span></td>
                          <td class="text-end" style="padding: 0.5rem 0; color: #3F4254;"><span data-bs-toggle="tooltip" data-bs-placement="top" :title="getCompleteValue(pmtd.total_eload_sc)">{{ formatBusinessSegmentValue(pmtd.total_eload_sc) }}</span></td>
                          <td class="text-end" style="padding: 0.5rem 0; color: #3F4254;"><span data-bs-toggle="tooltip" data-bs-placement="top" :title="getCompleteValue(currentMonth.total_eload_sc)">{{ formatBusinessSegmentValue(currentMonth.total_eload_sc) }}</span></td>
                        </tr>
                        <tr class="border-bottom" style="border-bottom-width: 2px !important">
                          <td colspan="2" style="padding: 0.5rem 0 1rem 0; color: #A1A5B7; font-weight: 600;">Total</td>
                          <td class="text-end" style="padding: 0.5rem 0 1rem 0; font-weight: 600; color: #3F4254;"><span data-bs-toggle="tooltip" data-bs-placement="top" :title="getCompleteValue(totalPmGTV)">{{ formatBusinessSegmentValue(totalPmGTV) }}</span></td>
                          <td class="text-end" style="padding: 0.5rem 0 1rem 0; font-weight: 600; color: #3F4254;"><span data-bs-toggle="tooltip" data-bs-placement="top" :title="getCompleteValue(totalPmtdGTV)">{{ formatBusinessSegmentValue(totalPmtdGTV) }}</span></td>
                          <td class="text-end" style="padding: 0.5rem 0 1rem 0; font-weight: 600; color: #3F4254;"><span data-bs-toggle="tooltip" data-bs-placement="top" :title="getCompleteValue(totalCurrentGTV)">{{ formatBusinessSegmentValue(totalCurrentGTV) }}</span></td>
                        </tr>
                        <!-- Retail Section -->
                        <tr>
                          <td rowspan="4" class="fw-bold align-top" style="padding: 0.5rem 0; color: #3F4254;">Revenue</td>
                          <td style="padding: 0.5rem 0; color: #A1A5B7;">MDR</td>
                          <td class="text-end" style="padding: 0.5rem 0; color: #3F4254;"><span data-bs-toggle="tooltip" data-bs-placement="top" :title="getCompleteValue(mdrPmRevenue)">{{ formatBusinessSegmentValue(mdrPmRevenue) }}</span></td>
                          <td class="text-end" style="padding: 0.5rem 0; color: #3F4254;"><span data-bs-toggle="tooltip" data-bs-placement="top" :title="getCompleteValue(mdrPmtdRevenue)">{{ formatBusinessSegmentValue(mdrPmtdRevenue) }}</span></td>
                          <td class="text-end" style="padding: 0.5rem 0; color: #3F4254;"><span data-bs-toggle="tooltip" data-bs-placement="top" :title="getCompleteValue(mdrCurrentRevenue)">{{ formatBusinessSegmentValue(mdrCurrentRevenue) }}</span></td>
                        </tr>
                        <tr>
                          <td style="padding: 0.5rem 0; color: #A1A5B7;">Kolek Fee</td>
                          <td class="text-end" style="padding: 0.5rem 0; color: #3F4254;"><span data-bs-toggle="tooltip" data-bs-placement="top" :title="getCompleteValue(kolekPmRevenue)">{{ formatBusinessSegmentValue(kolekPmRevenue) }}</span></td>
                          <td class="text-end" style="padding: 0.5rem 0; color: #3F4254;"><span data-bs-toggle="tooltip" data-bs-placement="top" :title="getCompleteValue(kolekPmtdRevenue)">{{ formatBusinessSegmentValue(kolekPmtdRevenue) }}</span></td>
                          <td class="text-end" style="padding: 0.5rem 0; color: #3F4254;"><span data-bs-toggle="tooltip" data-bs-placement="top" :title="getCompleteValue(kolekCurrentRevenue)">{{ formatBusinessSegmentValue(kolekCurrentRevenue ) }}</span></td>
                        </tr>
                        <tr>
                          <td style="padding: 0.5rem 0; color: #A1A5B7;">Transfer Out</td>
                          <td class="text-end" style="padding: 0.5rem 0; color: #3F4254;"><span data-bs-toggle="tooltip" data-bs-placement="top" :title="getCompleteValue(previousMonth.total_outgoing_transfer_fee)">{{ formatBusinessSegmentValue(previousMonth.total_outgoing_transfer_fee) }}</span></td>
                          <td class="text-end" style="padding: 0.5rem 0; color: #3F4254;"><span data-bs-toggle="tooltip" data-bs-placement="top" :title="getCompleteValue(pmtd.total_outgoing_transfer_fee)">{{ formatBusinessSegmentValue(pmtd.total_outgoing_transfer_fee) }}</span></td>
                          <td class="text-end" style="padding: 0.5rem 0; color: #3F4254;"><span data-bs-toggle="tooltip" data-bs-placement="top" :title="getCompleteValue(currentMonth.total_outgoing_transfer_fee)">{{ formatBusinessSegmentValue(currentMonth.total_outgoing_transfer_fee) }}</span></td>
                        </tr>
                        <tr>
                          <td style="padding: 0.5rem 0; color: #A1A5B7;">E-Load SC</td>
                          <td class="text-end" style="padding: 0.5rem 0; color: #3F4254;"><span data-bs-toggle="tooltip" data-bs-placement="top" :title="getCompleteValue(previousMonth.total_eload_sc)">{{ formatBusinessSegmentValue(previousMonth.total_eload_sc) }}</span></td>
                          <td class="text-end" style="padding: 0.5rem 0; color: #3F4254;"><span data-bs-toggle="tooltip" data-bs-placement="top" :title="getCompleteValue(pmtd.total_eload_sc)">{{ formatBusinessSegmentValue(pmtd.total_eload_sc) }}</span></td>
                          <td class="text-end" style="padding: 0.5rem 0; color: #3F4254;"><span data-bs-toggle="tooltip" data-bs-placement="top" :title="getCompleteValue(currentMonth.total_eload_sc)">{{ formatBusinessSegmentValue(currentMonth.total_eload_sc) }}</span></td>
                        </tr>
                        <tr class="border-bottom">
                          <td colspan="2" style="padding: 0.5rem 0; color: #A1A5B7; font-weight: 600;">Total</td>
                          <td class="text-end" style="padding: 0.5rem 0; font-weight: 600; color: #3F4254;"><span data-bs-toggle="tooltip" data-bs-placement="top" :title="getCompleteValue(totPmRevenue)">{{ formatBusinessSegmentValue(totPmRevenue) }}</span></td>
                          <td class="text-end" style="padding: 0.5rem 0; font-weight: 600; color: #3F4254;"><span data-bs-toggle="tooltip" data-bs-placement="top" :title="getCompleteValue(totPmtdRevenue)">{{ formatBusinessSegmentValue(totPmtdRevenue) }}</span></td>
                          <td class="text-end" style="padding: 0.5rem 0; font-weight: 600; color: #3F4254;"><span data-bs-toggle="tooltip" data-bs-placement="top" :title="getCompleteValue(totCurrentRevenue)">{{ formatBusinessSegmentValue(totCurrentRevenue) }}</span></td>
                        </tr>
                        <!-- CM1 -->
                        <tr>
                          <td rowspan="4" class="fw-bold align-top" style="padding: 0.5rem 0; color: #3F4254;">CM1</td>
                          <td style="padding: 0.5rem 0; color: #A1A5B7;">MDR</td>
                          <td class="text-end" style="padding: 0.5rem 0; color: #3F4254;"><span data-bs-toggle="tooltip" data-bs-placement="top" :title="getCompleteValue(mdrPmCm1)">{{ formatBusinessSegmentValue(mdrPmCm1) }}</span></td>
                          <td class="text-end" style="padding: 0.5rem 0; color: #3F4254;"><span data-bs-toggle="tooltip" data-bs-placement="top" :title="getCompleteValue(mdrPmtdCm1)">{{ formatBusinessSegmentValue(mdrPmtdCm1) }}</span></td>
                          <td class="text-end" style="padding: 0.5rem 0; color: #3F4254;"><span data-bs-toggle="tooltip" data-bs-placement="top" :title="getCompleteValue(mdrCurrentCm1)">{{ formatBusinessSegmentValue(mdrCurrentCm1) }}</span></td>
                        </tr>
                        <tr>
                          <td style="padding: 0.5rem 0; color: #A1A5B7;">Kolek Fee</td>
                          <td class="text-end" style="padding: 0.5rem 0; color: #3F4254;"><span data-bs-toggle="tooltip" data-bs-placement="top" :title="getCompleteValue(kolekPmCm1)">{{ formatBusinessSegmentValue(kolekPmCm1) }}</span></td>
                          <td class="text-end" style="padding: 0.5rem 0; color: #3F4254;"><span data-bs-toggle="tooltip" data-bs-placement="top" :title="getCompleteValue(kolekPmtdCm1)">{{ formatBusinessSegmentValue(kolekPmtdCm1) }}</span></td>
                          <td class="text-end" style="padding: 0.5rem 0; color: #3F4254;"><span data-bs-toggle="tooltip" data-bs-placement="top" :title="getCompleteValue(kolekCurrentCm1)">{{ formatBusinessSegmentValue(kolekCurrentCm1) }}</span></td>
                        </tr>
                        <tr>
                          <td style="padding: 0.5rem 0; color: #A1A5B7;">Transfer Out</td>
                          <td class="text-end" style="padding: 0.5rem 0; color: #3F4254;"><span data-bs-toggle="tooltip" data-bs-placement="top" :title="getCompleteValue(transferPmCm1)">{{ formatBusinessSegmentValue(transferPmCm1) }}</span></td>
                          <td class="text-end" style="padding: 0.5rem 0; color: #3F4254;"><span data-bs-toggle="tooltip" data-bs-placement="top" :title="getCompleteValue(transferPmtdCm1)">{{ formatBusinessSegmentValue(transferPmtdCm1) }}</span></td>
                          <td class="text-end" style="padding: 0.5rem 0; color: #3F4254;"><span data-bs-toggle="tooltip" data-bs-placement="top" :title="getCompleteValue(transferCurrentCm1)">{{ formatBusinessSegmentValue(transferCurrentCm1) }}</span></td>
                        </tr>
                        <tr>
                          <td style="padding: 0.5rem 0; color: #A1A5B7;">E-Load SC</td>
                          <td class="text-end" style="padding: 0.5rem 0; color: #3F4254;"><span data-bs-toggle="tooltip" data-bs-placement="top" :title="getCompleteValue(previousMonth.total_eload_sc)">{{ formatBusinessSegmentValue(previousMonth.total_eload_sc) }}</span></td>
                          <td class="text-end" style="padding: 0.5rem 0; color: #3F4254;"><span data-bs-toggle="tooltip" data-bs-placement="top" :title="getCompleteValue(pmtd.total_eload_sc)">{{ formatBusinessSegmentValue(pmtd.total_eload_sc) }}</span></td>
                          <td class="text-end" style="padding: 0.5rem 0; color: #3F4254;"><span data-bs-toggle="tooltip" data-bs-placement="top" :title="getCompleteValue(currentMonth.total_eload_sc)">{{ formatBusinessSegmentValue(currentMonth.total_eload_sc) }}</span></td>
                        </tr>
                        <tr class="border-bottom">
                          <td colspan="2" style="padding: 0.5rem 0; color: #A1A5B7; font-weight: 600;">Total</td>
                          <td class="text-end" style="padding: 0.5rem 0; font-weight: 600; color: #3F4254;"><span data-bs-toggle="tooltip" data-bs-placement="top" :title="getCompleteValue(totPmCm1)">{{ formatBusinessSegmentValue(totPmCm1) }}</span></td>
                          <td class="text-end" style="padding: 0.5rem 0; font-weight: 600; color: #3F4254;"><span data-bs-toggle="tooltip" data-bs-placement="top" :title="getCompleteValue(totPmtdCm1)">{{ formatBusinessSegmentValue(totPmtdCm1) }}</span></td>
                          <td class="text-end" style="padding: 0.5rem 0; font-weight: 600; color: #3F4254;"><span data-bs-toggle="tooltip" data-bs-placement="top" :title="getCompleteValue(totCurrentCm1)">{{ formatBusinessSegmentValue(totCurrentCm1) }}</span></td>
                        </tr>
                        <!-- Deduction -->
                        <tr>
                          <td rowspan="3" class="fw-bold align-top" style="padding: 0.5rem 0; color: #3F4254;">Deduction</td>
                          <td style="padding: 0.5rem 0; color: #A1A5B7;">Netbank Share</td>
                          <td class="text-end" style="padding: 0.5rem 0; color: #3F4254;"><span data-bs-toggle="tooltip" data-bs-placement="top" :title="getCompleteValue(totPmNetbankShare)">{{ formatBusinessSegmentValue(totPmNetbankShare) }}</span></td>
                          <td class="text-end" style="padding: 0.5rem 0; color: #3F4254;"><span data-bs-toggle="tooltip" data-bs-placement="top" :title="getCompleteValue(totPmtdNetbankShare)">{{ formatBusinessSegmentValue(totPmtdNetbankShare) }}</span></td>
                          <td class="text-end" style="padding: 0.5rem 0; color: #3F4254;"><span data-bs-toggle="tooltip" data-bs-placement="top" :title="getCompleteValue(totCurrentNetbankShare)">{{ formatBusinessSegmentValue(totCurrentNetbankShare) }}</span></td>
                        </tr>
                        <tr>
                          <td style="padding: 0.5rem 0; color: #A1A5B7;">Merchant Kita</td>
                          <td class="text-end" style="padding: 0.5rem 0; color: #3F4254;"><span data-bs-toggle="tooltip" data-bs-placement="top" :title="getCompleteValue(totPmMk)">{{ formatBusinessSegmentValue(totPmMk) }}</span></td>
                          <td class="text-end" style="padding: 0.5rem 0; color: #3F4254;"><span data-bs-toggle="tooltip" data-bs-placement="top" :title="getCompleteValue(totPmtdMk)">{{ formatBusinessSegmentValue(totPmtdMk) }}</span></td>
                          <td class="text-end" style="padding: 0.5rem 0; color: #3F4254;"><span data-bs-toggle="tooltip" data-bs-placement="top" :title="getCompleteValue(totCurrentMk)">{{ formatBusinessSegmentValue(totCurrentMk) }}</span></td>
                        </tr>
                        <tr>
                          <td style="padding: 0.5rem 0; color: #A1A5B7;">Transfer Out</td>
                          <td class="text-end" style="padding: 0.5rem 0; color: #3F4254;"><span data-bs-toggle="tooltip" data-bs-placement="top" :title="getCompleteValue(previousMonth.total_outgoing_netbank_share)">{{ formatBusinessSegmentValue(previousMonth.total_outgoing_netbank_share) }}</span></td>
                          <td class="text-end" style="padding: 0.5rem 0; color: #3F4254;"><span data-bs-toggle="tooltip" data-bs-placement="top" :title="getCompleteValue(pmtd.total_outgoing_netbank_share)">{{ formatBusinessSegmentValue(pmtd.total_outgoing_netbank_share) }}</span></td>
                          <td class="text-end" style="padding: 0.5rem 0; color: #3F4254;"><span data-bs-toggle="tooltip" data-bs-placement="top" :title="getCompleteValue(currentMonth.total_outgoing_netbank_share)">{{ formatBusinessSegmentValue(currentMonth.total_outgoing_netbank_share) }}</span></td>
                        </tr>
                        <tr class="border-bottom">
                          <td colspan="2" style="padding: 0.5rem 0; color: #A1A5B7; font-weight: 600;">Total</td>
                          <td class="text-end" style="padding: 0.5rem 0; font-weight: 600; color: #3F4254;"><span data-bs-toggle="tooltip" data-bs-placement="top" :title="getCompleteValue(totalPmDeductions)">{{ formatBusinessSegmentValue(totalPmDeductions) }}</span></td>
                          <td class="text-end" style="padding: 0.5rem 0; font-weight: 600; color: #3F4254;"><span data-bs-toggle="tooltip" data-bs-placement="top" :title="getCompleteValue(totalPmtdDeductions)">{{ formatBusinessSegmentValue(totalPmtdDeductions) }}</span></td>
                          <td class="text-end" style="padding: 0.5rem 0; font-weight: 600; color: #3F4254;"><span data-bs-toggle="tooltip" data-bs-placement="top" :title="getCompleteValue(totalCurrentDeductions)">{{ formatBusinessSegmentValue(totalCurrentDeductions) }}</span></td>
                        </tr>


                        <tr class="border-bottom">
                          <td class="fw-bold align-top" style="padding: 0.5rem 0; color: #3F4254;">Total CM2</td>
                          <td style="padding: 0.5rem 0; color: #A1A5B7;"></td>
                          <td class="text-end" style="padding: 0.5rem 0; color: #3F4254;"><span data-bs-toggle="tooltip" data-bs-placement="top" :title="getCompleteValue(totPmCm2)">{{ formatBusinessSegmentValue(totPmCm2) }}</span></td>
                          <td class="text-end" style="padding: 0.5rem 0; color: #3F4254;"><span data-bs-toggle="tooltip" data-bs-placement="top" :title="getCompleteValue(totPmtdCm2)">{{ formatBusinessSegmentValue(totPmtdCm2) }}</span></td>
                          <td class="text-end" style="padding: 0.5rem 0; color: #3F4254;"><span data-bs-toggle="tooltip" data-bs-placement="top" :title="getCompleteValue(totCurrentCm2)">{{ formatBusinessSegmentValue(totCurrentCm2) }}</span></td>
                        </tr>

                        <tr class="border-bottom">
                          <td class="fw-bold align-top" style="padding: 0.5rem 0; color: #3F4254;">CM2% of Rev</td>
                          <td style="padding: 0.5rem 0; color: #A1A5B7;"></td>
                          <td class="text-end" style="padding: 0.5rem 0; color: #3F4254;"><span data-bs-toggle="tooltip" data-bs-placement="top" :title="pmPerCm2OfRev">{{ pmPerCm2OfRev }}%</span></td>
                          <td class="text-end" style="padding: 0.5rem 0; color: #3F4254;"><span data-bs-toggle="tooltip" data-bs-placement="top" :title="pmtdPerCm2OfRev">{{ pmtdPerCm2OfRev }}%</span></td>
                          <td class="text-end" style="padding: 0.5rem 0; color: #3F4254;"><span data-bs-toggle="tooltip" data-bs-placement="top" :title="currentPerCm2OfRev">{{ currentPerCm2OfRev }}%</span></td>
                        </tr>

                        <tr class="border-bottom">
                          <td class="fw-bold align-top" style="padding: 0.5rem 0; color: #3F4254;">CM2% of GTV</td>
                          <td style="padding: 0.5rem 0; color: #A1A5B7;"></td>
                          <td class="text-end" style="padding: 0.5rem 0; color: #3F4254;"><span data-bs-toggle="tooltip" data-bs-placement="top" :title="pmPerCm2OfGtv">{{ pmPerCm2OfGtv }}%</span></td>
                          <td class="text-end" style="padding: 0.5rem 0; color: #3F4254;"><span data-bs-toggle="tooltip" data-bs-placement="top" :title="pmtdPerCm2OfGtv">{{ pmtdPerCm2OfGtv }}%</span></td>
                          <td class="text-end" style="padding: 0.5rem 0; color: #3F4254;"><span data-bs-toggle="tooltip" data-bs-placement="top" :title="currentPerCm2OfGtv">{{ currentPerCm2OfGtv }}%</span></td>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<style scoped>
/* E-Load Dashboard Card Styles */
.card-label {
  color: #7E8299;
  font-weight: 600;
  font-size: 1rem;
}

.card-date {
  color: #A1A5B7;
}

.card-value-main {
  color: #3F4254;
}

.card-value-dark {
  color: #3F4254;
}

.peso-sign-gray {
  color: #A1A5B7;
  vertical-align: super;
  font-size: 0.6em;
}

/* Percentage badge text colors */
.text-neutral {
  color: #AFAFAF !important;
}

.cursor-pointer {
  cursor: pointer;
}
.percentage-badge-main {
  min-width: 70px;
  justify-content: center;
  font-size: 0.75rem;
  padding: 0.25rem 0.5rem !important;
}

.percentage-badge-small {
  min-width: unset !important;
  width: auto !important;
  justify-content: flex-start !important;
  margin-left: 0.2rem !important;
  font-size: 0.65rem !important;
  padding: 0.15rem 0.35rem !important;
  gap: 0.15rem !important;
}

/* Table cell tooltips */
td[data-bs-toggle="tooltip"] {
  cursor: pointer;
  position: relative;
}

/* Business Segment Table Styling */
.business-segment-table tbody td {
  padding: 1rem 0.5rem;
  font-size: 1.125rem;
  font-weight: 600;
  color: #3F4254;
  vertical-align: middle;
}

.business-segment-table tbody tr {
  border-bottom: 1px solid #dee2e6;
}

.business-segment-table tbody tr:last-child {
  border-bottom: none;
}

.business-segment-table thead tr.border-bottom,
.business-segment-table tr.border-bottom {
  border-bottom: 2px solid #dee2e6 !important;
}
.business-segment-table tbody td {
  border-bottom: 2px solid #dee2e6;
}

.business-segment-table tbody tr:last-child td {
  border-bottom: none !important;
}

.tab-view-active-label {
  color: var(--Gray-Gray-800, #3F4254);
  font-size: 14px;
  font-style: normal;
  font-weight: 600;
  line-height: 16px;
  border-bottom-width: 2px !important;
}
.tab-view-inactive-label {
  color: var(--Gray-Gray-500, #7E8299);
  font-size: 14px;
  font-weight: 500;
  line-height: 16px;
  cursor: pointer; 
}

/* Daily Transaction Table Styles */
.daily-transaction-title {
  font-size: 1.3rem;
  font-weight: 600;
  color: #181C32;
  line-height: 1.5;
}

.filter-label {
  font-size: 0.875rem;
  font-weight: 400;
  color: #7E8299;
  white-space: nowrap;
}

.date-picker-input {
  min-width: 300px !important;
  font-size: 14px !important;
  font-weight: 600 !important;
  border: 1px solid #E1E3EA !important;
  border-radius: 0.475rem !important;
  padding: 0.5rem 3rem 0.5rem 0.75rem !important;
  color: #181C32 !important;
  cursor: pointer !important;
}

/* Use deep selector to style flatpickr's dynamically created altInput while keeping scoped */
::v-deep .flatpickr-input,
::v-deep .flatpickr-input.active,
::v-deep .flatpickr-input.input,
::v-deep input.flatpickr-input[readonly],
::v-deep .form-control.date-picker-input.input {
  font-weight: 600 !important;
  padding-right: 0.8rem !important;
  font-size: 14px !important;
  min-width: 230px !important;
  color: #181C32 !important;
}

::v-deep .flatpickr-input:focus {
  border-color: #009EF7 !important;
  box-shadow: 0 0 0 0.2rem rgba(0, 158, 247, 0.1) !important;
}

.date-picker-input:focus {
  border-color: #009EF7 !important;
  box-shadow: 0 0 0 0.2rem rgba(0, 158, 247, 0.1) !important;
}

.date-picker-chevron {
  position: absolute;
  right: 16px;
  top: 50%;
  transform: translateY(-50%);
  pointer-events: none;
  z-index: 10;
}
  
/* Daily Transaction Table */
.daily-transaction-table {
  margin-bottom: 0;
}

.daily-transaction-table .table-header-row {
  border-bottom: 1px solid #E1E3EA;
}

.daily-transaction-table .table-date-label {
  font-size: 0.875rem;
  font-weight: 700;;
  color: #000000;
  padding: 0.75rem 1rem 0.75rem 0;
  border: none;
  text-align: left;
  white-space: nowrap;
}

.daily-transaction-table .table-date-header {
  font-size: 0.875rem;
  color: #000000;
  padding: 0.75rem 1rem;
  border: none;
  font-weight: 700;
  text-align: right;
  white-space: nowrap;
}

.daily-transaction-table .table-data-row {
  border: none;
}

.daily-transaction-table .table-row-label {
  font-size: 1rem;
  font-weight: 600;
  color: #181C32;
  padding: 1rem 1rem 1rem 0;
  text-align: left;
  white-space: nowrap;
  border: none;
}

.daily-transaction-table .table-data-cell {
  font-size: 1rem;
  font-weight: 400;
  color: #181C32;
  padding: 1rem 1rem;
  text-align: right;
  white-space: nowrap;
  border: none;
}

.daily-transaction-table .table-separator-row {
  border-bottom: 1px solid #E1E3EA;
}

.daily-transaction-table .table-separator-row td {
  padding-bottom: 1.5rem;
}

.daily-transaction-table .table-subheader-row {
  border: none;
}

.daily-transaction-table .table-subheader-label {
  font-size: 1rem;
  font-weight: 600;
  color: #181C32;
  padding: 1.5rem 1rem 1rem 0;
  text-align: left;
  white-space: nowrap;
  border: none;
}

.daily-transaction-table .table-subheader-row td {
  padding-top: 1.5rem;
}

.daily-transaction-table .table-provider-label {
  font-size: 1rem;
  font-weight: 400;
  color: #181C32;
  padding: 1rem 1rem 1rem 2rem;
  text-align: left;
  white-space: nowrap;
  border: none;
}

/* Custom styles to complement Bootstrap */
.table th {
  border-top: none;
  font-size: 0.85rem;
  padding: 0.75rem 0.5rem;
}

.table td {
  padding: 0.5rem;
  font-size: 0.875rem;
  vertical-align: middle;
}

.table-borderless td,
.table-borderless th {
  border: none;
}

/* Cursor pointer for interactive elements */
.cursor-pointer {
  cursor: pointer;
}


/* Ensure proper spacing for responsive design */
@media (max-width: 768px) {
  .table-responsive {
    font-size: 0.8rem;
  }
  
  .card-body {
    padding: 1rem 0.75rem;
  }
  
  /* Stack cards on mobile */
  .col-lg-4 {
    margin-bottom: 1rem;
  }
}

/* Small mobile devices */
@media (max-width: 576px) {
  .table-responsive {
    font-size: 0.75rem;
  }
  
  .card-body {
    padding: 0.75rem 0.5rem;
  }
  
  h3 {
    font-size: 1.5rem;
  }
}

.coming-soon-overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100vh;
  background-color: rgba(0, 0, 0, 0.75);
  z-index: 5;
  display: flex;
  justify-content: center;
  align-items: center;
}

.coming-soon-content {
  background: white;
  padding: 3rem 2rem;
  border-radius: 12px;
  box-shadow: 0 10px 30px rgba(0, 0, 0, 0.3);
  max-width: 400px;
  width: 90%;
  animation: fadeInUp 0.5s ease-out;
}

@keyframes fadeInUp {
  from {
    opacity: 0;
    transform: translateY(30px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}
</style>

<style>
.dashboard-tooltip-left .tooltip-inner {
  text-align: left !important;
}
.dashboard-tooltip-left .tooltip-inner .dashboard-tooltip-title {
  font-weight: 600;
  font-size: 0.875rem;
}
</style>
